const localizations = {
  'button.cancel': '取消',
  'button.delete': '删除',
  'button.close': '关闭',
  'button.select': '选择',
  'button.selected': '已选择',
  'button.save-changes': '保存更改',
  'button.yes-delete': '是，删除',
  'button.reset': '重置',
  'button.reload': '重新加载',
  'button.to-dashboard': '返回仪表板页面',
  'button.to-navigation': '返回导航页面',
  'button.back': '返回',
  'button.login': '前往登录页面',
  'code-preview.copied': '已复制',
  'code-preview.copy': '复制代码',
  'app.contact-integrator.notification': '如需使用这些功能，请联系您的集成经理。',
  'app.multi-select.countries.selected': '已选择{number}个国家/地区（共{total}个）',
  'app.multi-select.unselect': '取消全选',
  'app.multi-select.search': '搜索',
  'app.multi-select.empty': '什么都没找到',

  'app.success.title': '成功',

  'app.error.title': '错误',
  'app.error.submit-form': '提交表单时发生错误。',
  'app.error.page.label': '无法加载完整页面',
  'app.error.page.text': '项目页部分加载失败。<br></br>返回导航页面。',
  'app.error.page.footer': '<doc>文档</doc> • <help>帮助</help> • <chat>聊天联系</chat>',
  'app.error.statistic.tooltip': '获取该数据时发生错误。请稍后重试。',
  'app.error.user-groups.tooltip': '获取用户组时发生错误。请稍后重试。',
  'app.error.000-000': '发生了问题。',
  /* Checklist errors */
  'app.error.011-001': '获取检查清单失败。',
  'app.error.011-002': '创建检查清单项失败。',
  'app.error.011-003': '删除检查清单项失败。',
  'app.error.011-004': '标记检查清单项为完成的请求错误。',
  'app.error.011-005': '项目检查清单进度请求错误。',
  /* User storage errors */
  'app.error.008-001': '未配置免密登录URL。',
  'app.error.008-002': '未配置用户验证URL。',
  'app.error.008-003': '未配置新用户URL。',
  'app.error.008-004': '未配置密码重置URL。',
  'app.error.008-005': 'PlayFab游戏ID无效。',
  'app.error.008-006': 'PlayFab API密钥无效。',
  'app.error.008-007': '通过邮箱获取外部帐户ID URL无效。',
  'app.error.008-008': '来自您API的响应无效。响应正文参数\"accountID\"必须包含用户ID。',
  'app.error.008-009': '自定义存储设置中包含无效URL。',
  'app.error.008-010': '未配置提问页面URL。',
  'app.error.008-011': '未配置设置新密码页面URL。',
  'app.error.008-012': '可选择值的格式无效。',
  'app.error.008-013': '未配置同意页面URL或无效。',
  'app.error.008-014': 'Okta集成未完成。',
  'app.error.008-015': 'SAML集成未完成。',
  'app.error.008-016': '未设置Firebase API密钥。',
  /* Custom SMS provider */
  'app.error.012-001': '自定义短信提供商管理请求错误。',
  'app.error.012-002': '已存在同名的提供商。',
  'app.error.012-003': '未找到自定义提供商。',
  'app.error.012-004': '未能使用所给参数创建提供商。',
  /* MFA*/
  'app.error.003-055': 'MFA URL 值不正确。请输入另一个 URL。',
  /* Custom email template */
  'app.error.003-070': '自定义邮件模板的自定义变量与艾克索拉默认邮件变量相同。',
  'app.error.003-071': '未找到自定义邮件模板。',
  'app.error.003-072': '错误的自定义邮件模板请求。',
  'app.error.003-073': '自定义邮件模板未知错误。请重试。',
  'app.error.003-074': '此登录管理器项目中已存在template_id的模板。',
  'app.error.003-075': '应先为英文区域创建一个邮件模板。',
  'app.error.003-076': '存在其他区域模板的情况下不能删除英文区域的自定义邮件模板。',
  'app.error.003-077': '此登录管理器项目中已存在用于该区域的自定义模板。',
  'app.error.003-078': '此登录管理器项目中不存在用于该区域的自定义模板。',
  'app.error.003-079': '短信模板禁用此类型。',
  'app.error.003-080': '未找到自定义模板。',
  'app.error.003-081': '模板未包含验证码的标记。',
  'app.error.003-082': '模板大小过大。请尝试减少文字。',
  'app.error.003-083': '区域无效。',
  /* Webhooks */
  'app.error.004-001': '未找到事件操作。',
  'app.error.004-002': '该事件配置的Webhook数量已达到最大（3个）。',
  'app.error.004-003': '已为指定类型的事件配置了指定URL的Webhook。',
  'app.error.004-004': '不支持所指定的URL。',
  /* Project errors */
  'app.error.003-019': '未找到项目。',
  'app.error.003-024': '此登录管理器项目已禁用密码重置。',
  'app.error.003-022': '此登录管理器项目配置错误。',
  'app.error.003-021': '此登录管理器项目已禁用用户认证。',
  'app.error.003-102': '通行密钥不能作为唯一的登录方式，请至少保留一种其他登录方式。',
  'app.error.003-023': '此登录管理器项目已禁用注册。',
  'app.error.003-064': "影子登录管理器项目不能超过1个。",
  'app.error.002-071': '超过登录管理器项目的数量限制。',
  /* Server errors */
  'app.error.000-001': '内部服务器错误。',
  'app.error.003-061': '未找到对象。',
  'app.error.010-004': '服务暂时不可用。',
  'app.error.010-050': '已超过期限。',
  /* Social errors */
  'app.error.002-065': '此操作对默认的社交网络提供商App不允许。',
  'app.error.010-037': '未找到社交网络提供商。',
  'app.error.010-043': '社交网络凭证无效。',
  'app.error.010-044': '未找到该社交账号。',
  'app.error.010-006': "无法解绑：这是该用户唯一的登录方式。",
  /* User errors */
  'app.error.002-054': '超过允许的搜索尝试数量限制。请等待一会再尝试。',
  'app.error.002-056': '手机号无效。',
  'app.error.003-007': '用户帐户未验证。',
  'app.error.003-004': '已存在使用所指定邮箱地址的用户。',
  'app.error.003-012': '已存在使用该手机号的用户。',
  'app.error.003-008': '用户帐户未验证。',
  'app.error.003-009': '用户搜索请求错误。',
  'app.error.003-010': '用户已验证过该邮箱地址。',
  'app.error.009-005': "已达到用户导出限制。请稍后重试。",
  /* Validation errors */
  'app.error.002-038': '设置状态应使用有效的JSON字符串。',
  'app.error.002-039': '未能保存验证设置。请稍后重试。',
  'app.error.002-041': '使用所给参数创建字段失败。',
  'app.error.002-042': '未能通过此API方法用所给名称更改字段。',
  'app.error.002-047': '点击下方的断开连接按钮。然后使用您的Mailchimp ID，选择您的受众并重试。',
  'app.error.002-048': '点击下方的断开连接按钮。然后使用您的Mailchimp ID，选择您的受众并重试。',
  /* Attributes errors */
  'app.error.060-001': '用户属性与当前JSON机制不对应。',
  'app.error.060-002': '属性重复。',
  'app.error.060-003': '传入的属性格式无效。',
  'app.error.060-004': 'JSON机制无效或定义的属性具有的嵌套层级超过1层。',
  /* Role errors */
  'app.error.010-049': "您没有此页面的访问权限。请联系您这边的项目管理员。",
  /* Token errors */
  'app.error.999-999': "请尝试重新登录。",
  /* Custom OAuth 2.0 error */
  'app.error.013-003': "其他项目中已存在该名称的自定义身份提供商。请使用其他名称。",

  'app.error-title.mailchimp-not-found': '找不到Mailchimp受众',

  'app.validation.required': '此字段为必填。',
  'app.validation.characters': '最大长度：{number}个字符',
  'app.validation.characters.min': '最小长度：{minNumber}个字符',
  'app.validation.characters-only-hyphen-underscore': '请使用字母和数字。也可使用连字符和下划线，但不能位于开头或结尾，且不能相邻。',
  'app.validation.url-invalid': '无效的URL',
  'app.validation.url-duplicate': "无法添加重复的URL",
  'app.validation.value-invalid': '无效值',
  'app.validation.value-less': '值应大于{number}',
  'app.validation.value-more': '值应小于{number}',
  'app.validation.phone-invalid': '手机号格式无效',
  'app.validation.not-project-name': '项目名称无效',
  'app.validation.mailchimp-key-length': '输入36或37个字符的API密钥。',
  'app.validation.old-widget-version-incorrect': 'CSS版本({cssVersion})必须与小组件版本({widgetVersion})一致。请将CSS版本更改为{widgetVersion}。',
  'app.validation.json-schema': '该机制不是有效的JSON对象。',
  "app.validation.color.hex": "颜色应为有效的HEX值",
  "app.validation.logo_url.required": "Logo图片为必需",
  "app.validation.logo_url.upload-error": "无法上传图片。请重试。",
  "app.validation.logo_url.size-error": "上传的图片不能超过300KB",
  "app.validation.custom_style.upload-error": "无法上传CSS文件。请重试",
  "app.validation.duplicate.valid-url": "URL已存在。请不要添加相同的URL两次。",
  "app.validation.cors-origin-only": "CORS源不能包含域名后的路径。",

  'form.select.country-name.AD': '安道​​尔',
  'form.select.country-name.AE': '阿联酋',
  'form.select.country-name.AF': '阿富汗',
  'form.select.country-name.AG': '安提瓜和巴布达',
  'form.select.country-name.AI': '安圭拉',
  'form.select.country-name.AL': '阿尔巴尼亚',
  'form.select.country-name.AM': '亚美尼亚',
  'form.select.country-name.AO': '安哥拉',
  'form.select.country-name.AQ': '南极洲',
  'form.select.country-name.AR': '阿根廷',
  'form.select.country-name.AS': '美属萨摩亚',
  'form.select.country-name.AT': '奥地利',
  'form.select.country-name.AU': '澳大利亚',
  'form.select.country-name.AW': '阿鲁巴岛',
  'form.select.country-name.AX': '奥兰群岛',
  'form.select.country-name.AZ': '阿塞拜疆',
  'form.select.country-name.BA': '波斯尼亚和黑塞哥维那',
  'form.select.country-name.BB': '巴巴多斯',
  'form.select.country-name.BD': '孟加拉国',
  'form.select.country-name.BE': '比利时',
  'form.select.country-name.BF': '布基纳法索',
  'form.select.country-name.BG': '保加利亚',
  'form.select.country-name.BH': '巴林',
  'form.select.country-name.BI': '布隆迪',
  'form.select.country-name.BJ': '贝宁',
  'form.select.country-name.BL': '圣巴泰勒米岛',
  'form.select.country-name.BM': '百慕大',
  'form.select.country-name.BN': '文莱',
  'form.select.country-name.BO': '玻利维亚',
  'form.select.country-name.BQ': '博内尔岛、圣尤斯特歇斯和萨巴岛',
  'form.select.country-name.BR': '巴西',
  'form.select.country-name.BS': '巴哈马',
  'form.select.country-name.BT': '不丹',
  'form.select.country-name.BV': '布韦岛',
  'form.select.country-name.BW': '博茨瓦纳',
  'form.select.country-name.BY': '白俄罗斯',
  'form.select.country-name.BZ': '伯利兹',
  'form.select.country-name.CA': '加拿大',
  'form.select.country-name.CC': '科科斯群岛',
  'form.select.country-name.CD': '刚果民主共和国',
  'form.select.country-name.CF': '中非共和国',
  'form.select.country-name.CG': '刚果',
  'form.select.country-name.CH': '瑞士',
  'form.select.country-name.CI': "科特迪瓦",
  'form.select.country-name.CK': '库克群岛',
  'form.select.country-name.CL': '智利',
  'form.select.country-name.CM': '喀麦隆',
  'form.select.country-name.CN': '中国',
  'form.select.country-name.CO': '哥伦比亚',
  'form.select.country-name.CR': '哥斯达黎加',
  'form.select.country-name.CU': '古巴',
  'form.select.country-name.CV': '佛得角',
  'form.select.country-name.CW': '库拉索',
  'form.select.country-name.CX': '圣诞岛',
  'form.select.country-name.CY': '塞浦路斯',
  'form.select.country-name.CZ': '捷克共和国',
  'form.select.country-name.DE': '德国',
  'form.select.country-name.DJ': '吉布提',
  'form.select.country-name.DK': '丹麦',
  'form.select.country-name.DM': '多米尼加',
  'form.select.country-name.DO': '在多明尼加共和国',
  'form.select.country-name.DZ': '阿尔及利亚',
  'form.select.country-name.EC': '厄瓜多尔',
  'form.select.country-name.EE': '爱沙尼亚',
  'form.select.country-name.EG': '埃及',
  'form.select.country-name.EH': '西撒哈拉',
  'form.select.country-name.ER': '厄立特里亚',
  'form.select.country-name.ES': '西班牙',
  'form.select.country-name.ET': '埃塞俄比亚',
  'form.select.country-name.FI': '芬兰',
  'form.select.country-name.FJ': '斐济',
  'form.select.country-name.FK': '福克兰群岛',
  'form.select.country-name.FM': '密克罗尼西亚联邦',
  'form.select.country-name.FO': '法罗群岛',
  'form.select.country-name.FR': '法国',
  'form.select.country-name.GA': '加蓬',
  'form.select.country-name.GB': '英国',
  'form.select.country-name.GD': '格林纳达',
  'form.select.country-name.GE': '格鲁吉亚',
  'form.select.country-name.GF': '法属圭亚那',
  'form.select.country-name.GG': '根西岛',
  'form.select.country-name.GH': '加纳',
  'form.select.country-name.GI': '直布罗陀',
  'form.select.country-name.GL': '格陵兰',
  'form.select.country-name.GM': '冈比亚',
  'form.select.country-name.GN': '几内亚',
  'form.select.country-name.GP': '瓜德罗普岛',
  'form.select.country-name.GQ': '赤道几内亚',
  'form.select.country-name.GR': '希腊',
  'form.select.country-name.GS': '南乔治亚和南德桑威奇群岛',
  'form.select.country-name.GT': '危地马拉',
  'form.select.country-name.GU': '关岛',
  'form.select.country-name.GW': '几内亚比绍',
  'form.select.country-name.GY': '圭亚那',
  'form.select.country-name.HK': '香港',
  'form.select.country-name.HM': '赫德与麦克唐纳群岛',
  'form.select.country-name.HN': '洪都拉斯',
  'form.select.country-name.HR': '克罗地亚',
  'form.select.country-name.HT': '海地',
  'form.select.country-name.HU': '匈牙利',
  'form.select.country-name.ID': '印尼',
  'form.select.country-name.IE': '爱尔兰',
  'form.select.country-name.IL': '以色列',
  'form.select.country-name.IM': '马恩岛',
  'form.select.country-name.IN': '印度',
  'form.select.country-name.IO': '英属印度洋领地',
  'form.select.country-name.IQ': '伊拉克',
  'form.select.country-name.IR': '伊朗',
  'form.select.country-name.IS': '冰岛',
  'form.select.country-name.IT': '意大利',
  'form.select.country-name.JE': '泽西岛',
  'form.select.country-name.JM': '牙买加',
  'form.select.country-name.JO': '约旦',
  'form.select.country-name.JP': '日本',
  'form.select.country-name.KE': '肯尼亚',
  'form.select.country-name.KG': '吉尔吉斯斯坦',
  'form.select.country-name.KH': '柬埔寨',
  'form.select.country-name.KI': '基里巴斯',
  'form.select.country-name.KM': '科摩罗',
  'form.select.country-name.KN': '圣基茨和尼维斯',
  'form.select.country-name.KP': '朝鲜',
  'form.select.country-name.KR': '韩国',
  'form.select.country-name.KW': '科威特',
  'form.select.country-name.KY': '开曼群岛',
  'form.select.country-name.KZ': '哈萨克斯坦',
  'form.select.country-name.LA': '老挝',
  'form.select.country-name.LB': '黎巴嫩',
  'form.select.country-name.LC': '圣卢西亚',
  'form.select.country-name.LI': '列支敦士登',
  'form.select.country-name.LK': '斯里兰卡',
  'form.select.country-name.LR': '利比里亚',
  'form.select.country-name.LS': '莱索托',
  'form.select.country-name.LT': '立陶宛',
  'form.select.country-name.LU': '卢森堡',
  'form.select.country-name.LV': '拉脱维亚',
  'form.select.country-name.LY': '利比亚',
  'form.select.country-name.MA': '摩洛哥',
  'form.select.country-name.MC': '摩纳哥',
  'form.select.country-name.MD': '摩尔多瓦',
  'form.select.country-name.ME': '黑山共和国',
  'form.select.country-name.MF': '圣马丁岛',
  'form.select.country-name.MG': '马达加斯加',
  'form.select.country-name.MH': '马绍尔群岛',
  'form.select.country-name.MK': '马其顿',
  'form.select.country-name.ML': '马里',
  'form.select.country-name.MM': '缅甸',
  'form.select.country-name.MN': '蒙古',
  'form.select.country-name.MO': '澳门',
  'form.select.country-name.MP': '北马里亚纳群岛',
  'form.select.country-name.MQ': '马提尼克',
  'form.select.country-name.MR': '毛里塔尼亚',
  'form.select.country-name.MS': '蒙特塞拉特',
  'form.select.country-name.MT': '马耳他',
  'form.select.country-name.MU': '毛里求斯',
  'form.select.country-name.MV': '马尔代夫',
  'form.select.country-name.MW': '马拉维',
  'form.select.country-name.MX': '墨西哥',
  'form.select.country-name.MY': '马来西亚',
  'form.select.country-name.MZ': '莫桑比克',
  'form.select.country-name.NA': '纳米比亚',
  'form.select.country-name.NC': '新喀里多尼亚',
  'form.select.country-name.NE': '尼日尔',
  'form.select.country-name.NF': '诺福克岛',
  'form.select.country-name.NG': '尼日利亚',
  'form.select.country-name.NI': '尼加拉瓜',
  'form.select.country-name.NL': '荷兰',
  'form.select.country-name.NO': '挪威',
  'form.select.country-name.NP': '尼泊尔',
  'form.select.country-name.NR': '瑙鲁',
  'form.select.country-name.NU': '纽埃',
  'form.select.country-name.NZ': '新西兰',
  'form.select.country-name.OM': '阿曼',
  'form.select.country-name.PA': '巴拿马',
  'form.select.country-name.PE': '秘鲁',
  'form.select.country-name.PF': '法属波利尼西亚',
  'form.select.country-name.PG': '巴布亚新几内亚',
  'form.select.country-name.PH': '菲律宾',
  'form.select.country-name.PK': '巴基斯坦',
  'form.select.country-name.PL': '波兰',
  'form.select.country-name.PM': '圣皮埃尔和密克隆',
  'form.select.country-name.PN': '皮特凯恩群岛',
  'form.select.country-name.PR': '波多黎各',
  'form.select.country-name.PS': '巴勒斯坦',
  'form.select.country-name.PT': '葡萄牙',
  'form.select.country-name.PW': '帕劳',
  'form.select.country-name.PY': '巴拉圭',
  'form.select.country-name.QA': '卡塔尔',
  'form.select.country-name.RE': '留尼汪',
  'form.select.country-name.RO': '罗马尼亚',
  'form.select.country-name.RS': '塞尔维亚',
  'form.select.country-name.RU': '俄罗斯',
  'form.select.country-name.RW': '卢旺达',
  'form.select.country-name.SA': '沙特阿拉伯',
  'form.select.country-name.SB': '所罗门群岛',
  'form.select.country-name.SC': '塞舌尔',
  'form.select.country-name.SD': '苏丹',
  'form.select.country-name.SE': '瑞典',
  'form.select.country-name.SG': '新加坡',
  'form.select.country-name.SH': '圣赫勒拿-阿森松-特里斯坦达库尼亚',
  'form.select.country-name.SI': '斯洛文尼亚',
  'form.select.country-name.SJ': '斯瓦尔巴群岛和扬马延',
  'form.select.country-name.SK': '斯洛伐克',
  'form.select.country-name.SL': '塞拉利昂',
  'form.select.country-name.SM': '圣马力诺',
  'form.select.country-name.SN': '塞内加尔',
  'form.select.country-name.SO': '索马里',
  'form.select.country-name.SR': '苏里南',
  'form.select.country-name.SS': '南苏丹',
  'form.select.country-name.ST': '圣多美和普林西比',
  'form.select.country-name.SV': '萨尔瓦多',
  'form.select.country-name.SX': '圣马丁',
  'form.select.country-name.SY': '叙利亚',
  'form.select.country-name.SZ': '斯威士兰',
  'form.select.country-name.TC': '特克斯和凯科斯群岛',
  'form.select.country-name.TD': '乍得',
  'form.select.country-name.TF': '法属南极地区',
  'form.select.country-name.TG': '多哥',
  'form.select.country-name.TH': '泰国',
  'form.select.country-name.TJ': '塔吉克斯坦',
  'form.select.country-name.TK': '托克劳',
  'form.select.country-name.TL': '东帝汶',
  'form.select.country-name.TM': '土库曼斯坦',
  'form.select.country-name.TN': '突尼斯',
  'form.select.country-name.TO': '汤加',
  'form.select.country-name.TR': '土耳其',
  'form.select.country-name.TT': '特立尼达和多巴哥',
  'form.select.country-name.TV': '图瓦卢',
  'form.select.country-name.TW': '台湾',
  'form.select.country-name.TZ': '坦桑尼亚',
  'form.select.country-name.UA': '乌克兰',
  'form.select.country-name.UG': '乌干达',
  'form.select.country-name.UM': '美属外岛',
  'form.select.country-name.US': '美国',
  'form.select.country-name.UY': '乌拉圭',
  'form.select.country-name.UZ': '乌兹别克斯坦',
  'form.select.country-name.VA': '梵蒂冈城国',
  'form.select.country-name.VC': '圣文森特和格林纳丁斯',
  'form.select.country-name.VE': '委内瑞拉',
  'form.select.country-name.VG': '英属维尔京群岛',
  'form.select.country-name.VI': '美属维尔京群岛',
  'form.select.country-name.VN': '越南',
  'form.select.country-name.VU': '瓦努阿图',
  'form.select.country-name.WF': '瓦利斯和富图纳群岛',
  'form.select.country-name.WS': '萨摩亚',
  'form.select.country-name.YE': '也门',
  'form.select.country-name.YT': '马约特',
  'form.select.country-name.ZA': '南非',
  'form.select.country-name.ZM': '赞比亚',
  'form.select.country-name.ZW': '津巴布韦',
  'form.select.country-name.AN': '安的列斯群岛',
  'form.select.country-name.XK': '科索沃',
  'form.select.country-name.XX': '自动检测',

  'form.language.ar': '阿拉伯语',
  'form.language.bg': '保加利亚语',
  'form.language.cn': '中文（简体）',
  'form.language.cs': '捷克语',
  'form.language.de': '德语',
  'form.language.en': '英语',
  'form.language.es': '西班牙语',
  'form.language.fr': '法语',
  'form.language.he': '希伯来语',
  'form.language.hu': '匈牙利语',
  'form.language.it': '意大利语',
  'form.language.ja': '日语',
  'form.language.ko': '韩语',
  'form.language.pl': '波兰语',
  'form.language.pt': '葡萄牙语',
  'form.language.ro': '罗马尼亚语',
  'form.language.ru': '俄语',
  'form.language.th': '泰语',
  'form.language.tr': '土耳其语',
  'form.language.zh_TW': '中文（繁体）',
  'form.language.vi': '越南语',
  'form.language.zh_CN': '中文（简体）',

  'agreement.not-signed.notification': '自定义仅在签署产品许可协议后可用。要签署该协议，请前往<a>协议</a>部分。',

  'statistics.label': '统计数据',

  'analytics.selectors.date.placeholder': '选择日期',
  'analytics.selectors.all-logins.title': '登录管理器名称',
  'analytics.selectors.all-logins.placeholder': '所有登录管理器项目',
  'analytics.selectors.all-countries.title': '国家/地区',
  'analytics.selectors.all-countries.placeholder': '所有国家/地区',
  'analytics.charts.empty.title': '可用数据不足',
  'analytics.charts.empty.description': '需要更多数据才能生成图表。',
  'analytics.charts.loading': '正在加载...',
  'analytics.charts.failed.title': '加载失败',
  'analytics.charts.failed.description': '请检查连接，然后重试。',
  'analytics.charts.failed.refresh': '刷新图表',
  'analytics.charts.active-users': '活动用户',
  'analytics.charts.active-users.legend': '日活动用户',
  'analytics.charts.active-users.plot': '日活动用户',
  'analytics.charts.active-users.total': '总数',
  'analytics.charts.active-users.label': '与所选时间段之前{days, number}{days, plural, one {天} other {天}}相比',
  'analytics.charts.auth-methods': '认证方法',
  'analytics.charts.auth-methods.legend': '认证数',
  'analytics.charts.countries': '认证数（按国家/地区）',
  'analytics.charts.countries.title': '活动用户',

  'welcome-modal.title': '欢迎体验全新登录管理器',
  'welcome-modal.subtitle': '通过全新界面获得非凡登录管理器体验。',
  'welcome-modal.update-list.login-method': '选择登录方法并进行相应设置',
  'welcome-modal.update-list.checklist': '通过检查清单和和根据内容而变化的区块更快完成登录管理器的配置',
  'welcome-modal.update-list.try-login': '在发布前测试登录管理器项目和所有连接',
  'welcome-modal.footer.try-new': '前往新登录管理器',
  'welcome-modal.help-research.title': '帮助我们改进登录管理器',
  'welcome-modal.help-research.description': '发送邮件至<a>login@xsolla.com</a>参与使用性测试或告诉我们对新登录管理器的反馈。',

  'change-version.notification.back-old': '旧版登录管理器将于2022年3月更新为新版登录管理器。立即查看新版，或{link}',
  'change-version.notification.back-old.link': '返回旧版本（如需要）。',
  'change-version.notification.check-new': '旧版登录管理器将于2022年3月更新为新版登录管理器。{link}',
  'change-version.notification.check-new.link': '查看新版。',

  'dashboard.label': '仪表板',
  'dashboard.new-login': '新登录管理器项目',
  'dashboard.new-login.master': '创建标准登录管理器项目',
  'dashboard.new-login.shadow': '创建影子登录管理器项目',
  'dashboard.new-login.shadow.description': '用于存储平台帐户的登录管理器项目',
  'dashboard.new-login.babka-login': '新建OAuth 2.0客户端',
  'dashboard.login-card.loginId': '登录管理器ID',
  'dashboard.login-card.publishertId': '项目ID',
  'dashboard.login-card.date': '最近更改：{date}',
  'dashboard.login-card.copy': '复制ID',
  'dashboard.login-card.copied': '已复制',
  'dashboard.login-card.statistics.users': '总用户数',
  'dashboard.login-card.statistics.mau': 'MAU',
  'dashboard.login-card.statistics.mau.help': '此登录管理器项目最近30天的唯一活跃用户数量。',
  'dashboard.login-card.statistics.new-users': '新用户',
  'dashboard.login-card.statistics.new-users.help': '此登录管理器项目最近30天的新用户数量。',
  'dashboard.login-card.button': '配置',
  'dashboard.login-card.steps.button': '下一步',
  'dashboard.login-card.steps.label': '下一个登录管理器集成步骤',
  'dashboard.login-card.steps.completed': '已完成步骤',
  'dashboard.help.label': '获得每个步骤的帮助信息',
  'dashboard.help.faq.label': '常见问答',
  'dashboard.help.faq.text': '找到艾克索拉登录管理器常见问题的答案。',
  'dashboard.help.documentation.label': '开发者文档',
  'dashboard.help.documentation.text': '探索登录管理器集成指南与示例。',
  'dashboard.help.ask.label': '联系我们',
  'dashboard.help.ask.text-contact': '需要帮助？<a>联系集成团队。</a>',
  'dashboard.help.ask.text-feedback': '有意见或建议？<a>留言反馈</a>',
  'dashboard.connections.label': '连接',
  'dashboard.connections.website': '网站',
  'dashboard.connections.launcher': '启动器',
  'dashboard.connections.show-all': '显示全部',
  'dashboard.connections.hide-all': '隐藏全部',
  'dashboard.connections.add': '添加网站',
  'dashboard.connections.save': '保存',
  'dashboard.connections.info': '要将启动器关联到此登录管理器项目，请<a>前往帐户中的“启动器”部分</a>。',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=9121%3A38854
  'try-login.modal.title': '检查小组件？',
  'try-login.modal.text': '为确保小组件正常工作，应以该登录管理器项目初次使用用户的身份登录进行测试。您可以使用您的主帐户或创建一个测试用户帐户。',
  'try-login.modal.button.later': '稍后检查',
  'try-login.modal.button.now': '是，检查',
  'try-login.checklist.title': '检查您的小组件',
  'try-login.checklist.text': '您可以用主帐户或测试帐户进行登录，以确保小组件正常工作。',
  'try-login.checklist.button': '立即检查',
  'try-login.success.title': '此登录管理器工作正常',
  'try-login.success.features.label': '了解这些功能：',
  'try-login.success.support.label': '获取技术支持',
  'try-login.success.support.integration': '了解简单集成',
  'try-login.success.support.help': '浏览帮助中心',
  'try-login.error.title': '发生了问题',
  'try-login.error.text': '错误代码：{code}',
  'try-login.error.social': '目前登录管理器小组件在测试模式下不支持社交网络登录。<a>请在生产模式下尝试</a>。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2224%3A58397 */
  'users.settings.all-users': '所有用户', // TODO для задаче по добавлению выборки забаниных/активных пользователей
  'users.settings.back': '返回<b>用户数据库</b>',
  'users.settings.general-info.label': '常规信息',
  'users.settings.general-info.external': 'External ID',
  'users.settings.general-info.server-customer': 'Server Customer ID',
  'users.settings.general-info.nickname': '昵称 {nickname}',
  'users.settings.general-info.reset-pass': '重置密码',
  'users.settings.general-info.ban-user': '封禁用户',
  'users.settings.general-info.unban-user': '解封用户',
  'users.settings.general-info.registred': '注册时间',
  'users.settings.general-info.show-login-history': '显示登录历史',
  'users.settings.general-info.hide-login-history': '隐藏登录历史',
  'users.settings.general-info.data-fetching-error': '无法获取登录历史数据',
  'users.settings.general-info.no-login-history': '无可用的登录历史',
  'users.settings.general-info.table.date': '日期',
  'users.settings.general-info.table.country': '国家/地区',
  'users.settings.general-info.table.city': '市',
  'users.settings.general-info.table.ip-address': 'IP地址',
  'users.settings.group.label': '组',
  'users.settings.group.input-label': '组',
  'users.settings.group.select.add': '添加组',
  'users.settings.contact-info.label': '联系信息',
  'users.settings.contact-info.primary-email.label': '首选电子邮箱',
  'users.settings.contact-info.primary-email.resend': '重新发送验证邮件',
  'users.settings.contact-info.primary-email.resend.sucesss': '确认电子邮件已发送。',
  'users.settings.contact-info.primary-phone.label': '手机号码',
  'users.settings.contact-info.primary-email.checkbox': '跳过新主邮箱地址的确认邮件',
  'users.settings.additional-info.label': '其他信息',
  'users.settings.additional-info.country': '国家/地区',
  'users.settings.additional-info.age': '年龄',
  'users.settings.email.validation.invalid': '邮箱地址格式无效。',
  'users.settings.phone.validation.min': '最小长度：8个字符。',
  'users.settings.phone.validation.max': '最大长度：14个字符。',
  'users.settings.delete-user.button': '删除用户帐户',
  'users.settings.delete-user.subtitle': '删除的用户帐户无法恢复。',
  'users.settings.delete-user.alert.title': '是否删除用户帐户？',
  'users.settings.delete-user.alert.subtitle': '无法恢复删除的用户帐户。',
  'users.settings.delete-user.alert.checked-understand': '好，知道了',
  'users.settings.update-email.modal.title': '更改该邮箱地址的用户？',
  'users.settings.update-email.modal.subtitle': 'ID为{id}的用户正在使用该邮箱地址。如更改邮箱的用户，则先前用户的帐户将不再与该邮箱地址关联。',
  'users.settings.update-email.modal.checkbox': '我明白',
  'users.settings.update-email.modal.submit': '是，更改',
  'users.settings.general-info.login-type.device': '设备',
  'users.settings.general-info.login-type.email': '无密码电子邮件认证',
  'users.settings.general-info.login-type.firebase': 'Firebase',
  'users.settings.general-info.login-type.import': '导入',
  'users.settings.general-info.login-type.phone': '无密码电话认证',
  'users.settings.general-info.login-type.playfab': 'Playfab',
  'users.settings.general-info.login-type.proxy': '代理',
  'users.settings.general-info.login-type.server_custom_id': '服务器自定义 ID',
  'users.settings.general-info.login-type.social': '社交平台认证',
  'users.settings.general-info.login-type.xsolla_login': '电子邮件 / 密码',
  'users.settings.general-info.login-type': '授权类型',
  'users.settings.general-info.social-profile.provider_name': '社交平台',
  'users.settings.general-info.social-profile.social_id': '社交平台 ID',
  'users.settings.general-info.social-profile.created_at': '账号创建于',
  'users.settings.general-info.social-profile.remove': '移除',
  'users.settings.general-info.social-profile.remove.modal.title': '要解绑该社交网络登录方式吗？',
  'users.settings.general-info.social-profile.remove.modal.subtitle': '要从用户{userId}的帐户中解绑{provider}吗？在重新关联前，该用户将无法使用该方式登录。',
  'users.settings.general-info.social-profile.remove.modal.submit': '是，解绑',

  'users.header-block.mailchimp.pill.title': 'Mailchimp',
  'users.header-block.mailchimp.pill.dropdown.title': 'Mailchimp集成',
  'users.header-block.mailchimp.pill.dropdown.subtitle': '设置自动将登录管理器用户导出为Mailchimp audience。',
  'users.header-block.mailchimp.pill.dropdown.connect': '连接',

  'users.list-block.table.no-data.title': '无用户',
  'users.list-block.table.no-data.subtitle': '所有注册的用户将在此处显示。',
  'users.list-block.table.error.title': '更改搜索参数',
  'users.list-block.table.error.subtitle': "无法显示这些搜索参数的结果。请更改参数以查看用户列表。",
  'users.list-block.table.id-username': 'ID/用户名',
  'users.list-block.table.contacts': '联系信息',
  'users.list-block.table.contacts.help': '等待确认',
  'users.list-block.table.group': '组',
  'users.list-block.table.activity': '活动',
  'users.list-block.table.attributes': '属性',
  'users.list-block.navigation.manage-groups': '管理用户组',
  'users.list-block.navigation.export-users': '导出用户',
  'users.list-block.search-user.button': '搜索',
  'users.list-block.search-user.input-placeholder': '搜索用户',
  'users.list-block.select-group.select.placeholder': '选择组',
  'users.list-block.number-user': '{number, plural, one {找到了#个用户} other {找到了#个用户}}',
  'users.list-block.table.settings.ban': '封禁',
  'users.list-block.table.settings.view': '查看用户资料',
  'users.list-block.table.last-activity': '上次登录：<br></br>{date}',
  'users.list-block.select-mode.all': '所有用户',
  'users.list-block.select-mode.ban': '封禁的用户',
  'users.list-block.select-mode.active': '活动用户',
  'users.list-block.table.settings.unban': '从封禁列表删除',
  'users.list-block.table.settings.delete': '删除',
  'users.list-block.table.ban-date': '封禁日期：<br></br> {date}',
  'users.list-block.table.ban-info-row.title': '详细信息',
  'users.list-block.table.ban-info-row.date': '封禁至：',
  'users.list-block.table.ban-info-row.date.permanent': '永久封禁',
  'users.list-block.table.ban-info-row.reason': '封禁原因',
  'users.list-block.table.ban-modal.title': '封禁此用户？',
  'users.list-block.table.ban-modal.subtitle': '被封禁的用户在指定日期之前或直到您解封为止无法登录。',
  'users.list-block.table.ban-modal.profile.title': '用户资料',
  'users.list-block.table.ban-modal.profile.external-id': '外部ID {id}',
  'users.list-block.table.ban-modal.profile.register-date': '注册日期：{date}',
  'users.list-block.table.ban-modal.period.label': '封禁至：',
  'users.list-block.table.ban-modal.period.separator': '时间：',
  'users.list-block.table.ban-modal.permanent': '永久封禁',
  'users.list-block.table.ban-modal.reason.label': '封禁原因',
  'users.list-block.table.ban-modal.reason.description': '示例：您的帐户由于{{ban reason}}，在{{unban date}}之前被封禁。申请解封请联系{{support contact}}。',
  'users.list-block.table.ban-modal.reason.submit.ban': '是，封禁用户',
  'users.list-block.table.ban-modal.reason.submit.unban': '解封用户',
  'users.list-block.select-search-by': '搜索方式',
  'users.list-block.select-search-by.email': '邮箱地址',
  'users.list-block.select-search-by.phone': '手机号',
  'users.list-block.select-search-by.id': 'ID',
  'users.list-block.select-search-by.socialId': '社交网络ID',
  'users.list-block.select-search-by.username': '用户名',
  'users.list-block.select-search-by.nickname': '昵称',
  'users.list-block.select-search-by.customId': '服务器自定义ID',

  'users.export.title': '导出用户',
  'users.export.subtitle': '请指定接收导出的登录管理器用户的邮箱地址。',
  'users.export.subtitle-archive': '建议在Windows上使用7-Zip来解压压缩包。',
  'users.export.notification': '请查看<a>JWT签名页</a>来查找密钥形式的压缩包密码。',
  'users.export.email': '邮箱地址',
  'users.export.button': '导出',
  'users.export.success.label': '已发送导出请求',
  'users.export.success.sublabel': '我们将在几分钟后向指定的邮箱地址发送包含用户的压缩包。',

  'users.attributes.table.description.title': '属性名称',
  'users.attributes.table.description.tooltip': 'JSON机制文件的<b>description</b>字段。',
  'users.attributes.table.key.title': '密钥名称',
  'users.attributes.table.key.tooltip': 'JSON机制文件中的<b>properties</b>对象密钥字段。',
  'users.attributes.table.type.title': '类型',
  'users.attributes.table.type.tooltip': 'JSON机制文件的<b>type</b>字段。',
  'users.attributes.table.access.title': '访问权限',
  'users.attributes.table.access.tooltip': '显示属性的<b>访问类型</b>。',
  'users.attributes.table.readonly.title': '只读',
  'users.attributes.table.readonly.tooltip': '用户无法更新<b>只读</b>属性。',
  'users.attributes.table.value.title': '值',
  'users.attributes.table.value.tooltip': '属性值。',
  'users.attributes.table.permission.title': '权限',
  'users.attributes.table.permission.tooltip': '属性的<b>第三方</b>访问权限状态。',
  'users.attributes.table.access.private': '私有',
  'users.attributes.table.access.public': '公共',
  'users.attributes.table.schema-link': '您可以在<a>用户属性设置</a>中更改属性机制。',
  'users.attributes.table.empty.title': '未找到属性',
  'users.attributes.table.empty.subtitle': '您未上传JSON机制或为此用户添加任何属性',
  'users.attributes.table.search.placeholder': '搜索属性',
  'users.attributes.table.search.empty.title': '未找到属性',
  'users.attributes.table.search.empty.subtitle': '清空搜索字段以显示所有可用属性',
  'users.attributes.table.save-value': '保存',
  'users.attributes.table.type-error': '输入{type}类型值。',
  'users.attributes.table.publisher-project-id.title': '发布者项目 ID',
  'users.attributes.table.publisher-project-id.description': '发布者项目 ID 是您所选发布者项目的 ID。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6203%3A100097 */
  'check-list.main-links.title': '浏览登录管理器指南',
  'check-list.main-links.subtitle': '配置主要登录管理器设置',
  'check-list.main-links.documentation': '文档',
  'check-list.main-links.faq': '常见问答',

  'check-list.head-element.title': '登录管理器设置检查清单',
  'check-list.login-method.title': '登录方法',
  'check-list.login-method.subtitle': '主要登录方法设置',
  'check-list.selected_login_method.title': '选择登录方法',
  'check-list.selected_login_method.tooltip': '选择一种用户认证方式来提供必要的登录和注册功能。',
  'check-list.set_callback_url.title': '设置回调URL',
  'check-list.set_callback_url.tooltip': '设置允许将用户重定向到必要页面的URL。',
  'check-list.rest-steps.not-required': '下方的步骤并非必需，但建议您完成这些步骤以成功设置登录管理器：',
  'check-list.secure.title': '安全性',
  'check-list.secure.subtitle': '主要安全性设置',
  'check-list.set_up_oauth.title': '设置OAuth 2.0',
  'check-list.set_up_oauth.tooltip': '允许用户将其受保护的数据授权第三方网站或应用程序访问。',
  'check-list.copy_secret_key.title': '保存并保护密钥',
  'check-list.copy_secret_key.tooltip': '复制您的密钥并在您的一侧将其实现到代码中。',
  'check-list.authentication.title': '身份认证',
  'check-list.authentication.subtitle': '主要认证设置',
  'check-list.connected_social.title': '添加社交网络',
  'check-list.connected_social.tooltip': '配置社交网络让用户可以通过它们进行登录。',
  'check-list.miscellaneous_data.title': '设置杂项数据表单',
  'check-list.miscellaneous_data.tooltip': '通过一个额外表单收集用户数据。',
  'check-list.user-data-base.title': '用户数据库',
  'check-list.user-data-base.subtitle': '主要用户数据库设置',
  'check-list.set_up_storage.title': '设置用户数据存储',
  'check-list.set_up_storage.tooltip': '设置用户数据存储并管理用户凭证。',
  'check-list.supplementary_info.title': '设置补充用户信息表单',
  'check-list.supplementary_info.tooltip': '添加收集用户补充信息的数据表单。',
  'check-list.customization.title': '自定义',
  'check-list.customization.subtitle': '主要自定义设置',
  'check-list.widget_customization.title': '自定义小组件',
  'check-list.widget_customization.tooltip': '自定义小组件UI，让您的登录管理器小组件更有辨识度。',

  /* Navigation page */
  'navigation.main-alert': '点击编辑图标重命名您的登录管理器项目。登录管理器项目名称将用于发送给用户的邮件和消息中。',
  'navigation.delete-project': '删除项目',
  'navigation.save.project-name': '保存',
  'navigation.authentication-method.label': '登录方法',
  'navigation.authentication-method.configure.button': '配置',
  'navigation.authentication-method.alert': '单击登录方法设置回调URL并打开登录方法设置。可以更改登录方法，已保存的设置不会丢失。',
  'navigation.authentication-method.classic-widget.title': '经典登录',
  'navigation.authentication-method.classic-widget.subtitle': '优化了视觉效果、过程和功能，提升了包括社交网络登录在内的最终用户体验。<a>详细信息见登录管理器文档。</a>',
  'navigation.authentication-method.passwordless-widget.title': '免密登录',
  'navigation.authentication-method.passwordless-widget.subtitle': '让用户在无需输入密码的情况下通过邮箱地址、手机号码或社交网络登录。<a>详细信息见登录管理器文档。</a>',
  'navigation.authentication-method.social-widget.title': '社交网络登录',
  'navigation.authentication-method.social-widget.subtitle': '让用户通过社交网络登录。<a>详细信息见登录管理器文档。</a>',
  'navigation.authentication-method.example-project.modal': '此仅为预览，无法点击！',
  'navigation.settings.secure.label': '安全性',
  'navigation.settings.secure.oauth2.title': 'OAuth 2.0',
  'navigation.settings.secure.oauth2.subtitle': '让用户在不暴露凭证的情况下通过网站授予对其数据的有限访问。',
  'navigation.settings.secure.signature.title': 'JWT签名',
  'navigation.settings.secure.signature.subtitle': '选择用于JSON Web令牌(JWT)签名验证的密钥。',
  'navigation.settings.secure.multi-factor.title': '多因素认证政策',
  'navigation.settings.secure.multi-factor.subtitle': '要求用户在登录时完成额外验证步骤以防止未授权的访问。',
  'navigation.settings.user-db.label': '用户数据库',
  'navigation.settings.user-db.storage.title': '存储',
  'navigation.settings.user-db.storage.subtitle': '允许连接数据库以通过邮箱地址或用户名和密码来认证用户。',
  'navigation.settings.user-db.user-info.title': '补充用户信息',
  'navigation.settings.user-db.user-info.subtitle': '显示额外表单收集用户数据，用于向数据库添加额外用户信息。',
  'navigation.settings.user-db.user-attributes.title': '用户属性机制',
  'navigation.settings.user-db.user-attributes.subtitle': '下载及检索您的用户属性机制。',
  'navigation.settings.user-db.users.title': '用户',
  'navigation.settings.user-db.users.subtitle': '更改用户邮箱地址、重置密码、管理封禁列表、删除用户、管理用户属性及下载整个用户数据库的副本。',
  'navigation.settings.authentication.label': '身份认证',
  'navigation.settings.classic-login.label': '经典登录',
  'navigation.settings.classic-login.alert': '您可以轻松在经典、免密和社交网络登录之间切换，而不会丢失已保存的设置。<a>更改登录方法。</a>',
  'navigation.settings.settings.title': '设置',
  'navigation.settings.settings.subtitle': '配置免密登录方法让用户无需输入密码即可登录。',
  'navigation.settings.sign-up.title': '注册设置',
  'navigation.settings.sign-up.subtitle': '完成主要注册设置。',
  'navigation.settings.username.title': '用户名设置',
  'navigation.settings.username.subtitle': '要求用户在邮箱地址之外还提供用户名。',
  'navigation.settings.email-validation.title': '邮箱验证',
  'navigation.settings.email-validation.subtitle': '选择一种验证方法进行邮箱验证。',
  'navigation.settings.callback.title': '回调URL',
  'navigation.settings.callback.subtitle': '指定多个有效URL用于在用户认证成功后进行跳转。',
  'navigation.settings.email.title': '邮件设置',
  'navigation.settings.email.subtitle': '设置用于验证用户邮箱地址的链接以及验证方式。',
  'navigation.settings.classic-login.password.title': '密码设置',
  'navigation.settings.classic-login.password.subtitle': '手动创建或自动生成安全密码。',
  'navigation.settings.passwordless.label': '免密登录',
  'navigation.settings.social.label': '社交网络登录',
  'navigation.settings.authentication.social-connections.title': '社交网络登录',
  'navigation.settings.authentication.social-connections.subtitle': '允许用户选择一个社交网络进行登录。',
  'navigation.settings.authentication.enterprise-connections.title': 'OAuth 2.0登录连接',
  'navigation.settings.authentication.enterprise-connections.subtitle': '通过OAuth 2.0将您的授权界面关联至艾克索拉，让用户通过它进行登录',
  'navigation.settings.authentication.passkey.title': '通行密钥',
  'navigation.settings.authentication.passkey.subtitle': '支持用户使用指纹、面容或设备PIN码代替密码登录。',
  'navigation.settings.authentication.miscellaneous-data.title': '补充数据表单',
  'navigation.settings.authentication.miscellaneous-data.subtitle': "显示一个额外表单来收集用户数据。如果注册时未提供所需数据，可使用此形式。",
  'navigation.settings.authentication.publisher-platforms.title': '发布平台',
  'navigation.settings.authentication.api-settings.title': 'Login API集成',
  'navigation.settings.authentication.api-settings.subtitle': '通过Login API配置集成。',
  'navigation.settings.custom-providers.label': '通讯服务提供商',
  'navigation.settings.custom-providers.email.title': '邮件服务提供商',
  'navigation.settings.custom-providers.email.subtitle': '通过一个大流量邮箱服务收发所有邮件。',
  'navigation.settings.custom-providers.sms.title': '短信服务提供商',
  'navigation.settings.custom-providers.sms.subtitle': '通过一个大流量通讯服务收发所有短信消息。',
  'navigation.settings.customization.label': '自定义',
  'navigation.settings.customization.widget-customization.title': '小组件自定义',
  'navigation.settings.customization.widget-customization.subtitle': '设置小组件的语言和外观。',
  'navigation.settings.customization.email-customization.title': '邮件自定义',
  'navigation.settings.customization.email-customization.subtitle': '自定义发送给用户的邮件的外观。',
  'navigation.settings.customization.sms-customization.title': '短信自定义',
  'navigation.settings.customization.sms-customization.subtitle': '自定义发送给用户的短信消息。',
  'navigation.settings.legal.label': '法律设置',
  'navigation.settings.legal.terms-and-policies.title': '条款和政策',
  'navigation.settings.legal.terms-and-policies.subtitle': '提供条款和政策的链接以确保合规及定义与用户的法律关系。用户将在登录管理器小组件屏幕上看到这些链接。',
  'navigation.settings.legal.age-restrictions.title': '年龄限制',
  'navigation.settings.legal.age-restrictions.subtitle': '指定访问游戏的最低年龄限制。',

  'change-method.main-title': '认证方法',
  'change-method.main-subtitle': '在艾克索拉数据库或您自己的存储中安全存储和管理用户凭证。',
  'change-method.main-notification': '更改认证方法不会丢失已保存的设置。',
  'change-method.button.cancel': '取消',
  'change-method.button.save': '保存并设置',
  'change-method.methods.classic.title': '经典登录',
  'change-method.methods.classic.subtitle': '让用户通过用户名和密码进行注册和登录。',
  'change-method.methods.passwordless.title': '免密登录',
  'change-method.methods.passwordless.subtitle': '让用户在无需输入密码的情况下通过邮箱地址或手机号码进行登录。',
  'change-method.methods.social.title': '社交网络登录',
  'change-method.methods.social.subtitle': '让用户通过社交网络进行注册和登录。',

  'delete-project-form.description': '只能恢复30天以内删除的登录管理器项目。',
  'delete-project-form.title': '是否删除\"{projectName}\"项目？',
  'delete-project-form.input.title': '要删除登录管理器项目，请输入其名称',
  'delete-project-launchers.title': '无法删除\"{projectName}\"',
  'delete-project-launchers.description': '{projectName}项目已连接至一个启动器。必须先断开与它的连接。',
  'delete-project-launchers.notification': '可在启动器设置中断开登录管理器的连接。',
  'delete-project-launchers.link': '前往\"{launcherName}\"启动器设置',
  'delete-project-success.title': '已删除登录管理器项目',
  'delete-project-success.description': '要恢复此登录管理器项目，请<a>联系支持团队</a>。',

  'welcome-page.header.title': '欢迎使用艾克索拉登录管理器',
  'welcome-page.header.description': '提供本地化的无缝一键式认证体验，同时确保用户数据安全地处于您的掌握之中。',
  'welcome-page.header.create-login-button': '创建登录管理器项目',
  'welcome-page.header.annotation-integration': '集成过程<span>不超过20分钟</span>',
  'welcome-page.header.guide-link': '查看登录管理器集成指南',
  'welcome-page.features-list.title': '主要功能',
  'welcome-page.features-list.make-game.title': '让玩家身份认证变得无比简单',
  'welcome-page.features-list.make-game.description': '允许玩家通过社交网络个人资料轻松登录游戏，支持超过30个可信社交网络。',
  'welcome-page.features-list.data-laws.title': '确保符合全球数据法规',
  'welcome-page.features-list.data-laws.description': '符合信息保护法规、游戏时间限制及线上身份识别系统的规定。',
  'welcome-page.features-list.brand-identity.title': '添加自己的品牌标识',
  'welcome-page.features-list.brand-identity.description': '直接在发布商帐户中定制登录管理器小组件的外观和风格，甚至可通过CSS和HTML修改邮件的视觉设计以符合自己的品牌形象。',
  'welcome-page.features-list.own-your-database.title': '完全掌握自己的数据库',
  'welcome-page.features-list.own-your-database.description': '管理用户数据库的访问权限，例如更新邮箱地址、重新发送验证邮件、封禁、解封、删除用户以及导出数据到CSV文件。',
  'welcome-page.features-list.relevant-login-methods.title': '凸显用户最相关的登录方法',
  'welcome-page.features-list.relevant-login-methods.description': "根据玩家的历史记录和位置，将最相关的登录方法推到顶部。",
  'welcome-page.features-list.earn-layout-security.title': '通过高安全性获得用户忠诚度',
  'welcome-page.features-list.earn-layout-security.description': '使用符合强客户认证(SCA)要求的参数来确认玩家ID，将未授权数据访问的风险降至最低。',
  'welcome-page.features-list.dock-link': '更多功能',

  'create-login-page.title': '创建登录管理器项目',
  'create-login-page.description': '按照这些步骤轻松创建登录管理器项目，然后进行设置和自定义。',
  'create-login-page.notification': '选择要创建的登录管理器项目类型。每个选项有不同的设置步骤。登录管理器项目一旦创建将无法更改其类型。但您可以通过新建一个登录管理器项目来更改类型。',
  'create-login-page.documentation': '文档',
  'create-login-page.create': '创建并设置',
  'create-login-page.back': '返回<b>仪表板</b>',
  'create-login-page.master.label': '标准登录管理器项目',
  'create-login-page.master.description': '登录管理器提供本地化的无缝一键式认证体验，同时保证玩家数据安全、完整地处于您的掌握之中。',
  'create-login-page.shadow.label': '影子登录管理器项目',
  'create-login-page.shadow.description': '影子登录管理器可让您通过发布平台来认证用户身份。',
  'create-login-page.settings.label': '其他设置',
  'create-login-page.master.settings.text': '社交网络连接',
  'create-login-page.shadow.settings.text': '平台连接',
  'create-login-page.time.label': '创建所需时间',
  'create-login-page.master.time.text': '30分钟',
  'create-login-page.shadow.time.text': '15分钟',

  'settings.crumbs.login-type.classic-login': '经典登录',
  'settings.tabs.try-login.button': '尝试登录',

  "users.mailchimp": "Mailchimp",
  "users.mailchimp.head": "连接Mailchimp",
  "users.mailchimp.notification.title": "显示说明信息",
  "users.mailchimp.notification.description.mailchimp-api-key": '1. <b>输入您的Mailchimp API密钥。</b>可在您的<a1>Mailchimp帐户</a1>中找到。<br></br> 2. <b>选择</b>一个Mailchimp audience与登录管理器用户进行同步。您可以在您的<a2>Mailchimp帐户</a2>中管理audience。<br></br> 3. 单击<b>连接</b>保存更改并开始将登录管理器用户导出至Mailchimp帐户。<br></br>4. 前往<a3>补充用户信息页</a3>并在登录管理器小组件中勾选电子简讯同意复选框。<br></br><br></br>每次添加新的登录管理器用户后，新用户将自动导出至Mailchimp帐户。',
  "users.mailchimp.notification.description.mailchimp-merge-tags": "请确认该标签是否已存在于您的 Mailchimp 仪表板中。如果该标签已设置，我们的界面将无法再次添加，重复添加可能会导致意外错误。",
  "users.mailchimp.key.label": "Mailchimp API密钥",
  "users.mailchimp.key.placeholder": "输入36或37个字符的API密钥",
  "users.mailchimp.audience.label": "Mailchimp audience",
  "users.mailchimp.audience.empty.title": "您还没有任何audience",
  "users.mailchimp.audience.empty.text": "在您的<a>Mailchimp帐户</a>中创建您的首个audience，然后重试。",
  "users.mailchimp.confirm.label": "我确认根据<a>Importance of Permission</a>，来自我的audience的用户同意接收电子邮件。",
  "users.mailchimp.connect-form.button": "连接",
  "users.mailchimp.confirm-form.button": "确认",
  "users.mailchimp.export.alert.title": "正在导出到Mailchimp",
  "users.mailchimp.export.alert.message": "导出可能需要一段时间。您可以关闭此窗口。",
  "users.mailchimp.export.alert.button": "谢谢，关闭",
  "users.mailchimp.disconnect.title": "断开连接Mailchimp？",
  "users.mailchimp.disconnect.description": "登录管理器用户将不再导出到Mailchimp。再次连接时，您需要重新填写这些字段。",
  "users.mailchimp.button-dropdown.integration.title": "Mailchimp集成",
  "users.mailchimp.button-dropdown.integration.description": "设置自动将登录管理器用户导出为Mailchimp audience。",
  "users.mailchimp.button-dropdown.integration.button": "连接",
  "users.mailchimp.button-dropdown.fetching.title": "正在导出到Mailchimp",
  "users.mailchimp.button-dropdown.fetching.description": "导出时间取决于登录管理器列表中的用户数量。",
  "users.mailchimp.button-dropdown.export-completed.title": "已完成导出",
  "users.mailchimp.button-dropdown.export-completed.description": "已将登录管理器用户导出为Mailchimp audience。",
  "users.mailchimp.button-dropdown.export-completed.button": "断开连接",
  "users.mailchimp.merge-tags-form.button.skip": "跳過",
  "users.mailchimp.merge-tags-form.head": "使用 Mailchimp 合并标签",
  "users.mailchimp.merge-tags-form.add-tag": "添加合并标签",
  "users.mailchimp.merge-tags-form.edit-tag": "编辑合并标签",
  "users.mailchimp.merge-tags-form.field-label.placeholder": "字段标签",
  "users.mailchimp.merge-tags-form.merge-tag.placeholder": "合并标签",
  "users.mailchimp.merge-tags-form.field-label.error": "字段标签必须在 1 到 10 个字符之间",
  "users.mailchimp.merge-tags-form.merge-tag.error": "合并标签必须为 1 到 50 个字符之间",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750 */
  'configuration-page.menu.item.callback-url': '回调URL',
  'configuration-page.menu.item.signup-settings': '注册',
  'configuration-page.menu.item.username-settings': '用户名',
  'configuration-page.menu.item.password-settings': '密码',
  'configuration-page.menu.item.email-validation': '邮箱验证',

  'configuration-page.callback-urls.page-title': 'URL',
  'configuration-page.callback-urls.page-description': '用户成功登录应用程序后，认证服务器会用包含认证码或访问令牌的URL将用户重定向回应用程序。',

  'configuration-page.urls.callback-urls.title': '回调URL',
  'configuration-page.urls.callback-urls.description': '成功认证、邮箱验证或密码重置后将用户重定向到的回调URL。用户认证后，我们只会回调到这些URL。',
  'configuration-page.urls.callback-urls.notification': '请务必指定协议 — <u>https://</u>或<u>http://</u>。否则某些情况下回调可能失败。',
  'configuration-page.urls.callback-urls.input.title': '回调URL',
  'configuration-page.urls.callback-urls.input.placeholder': 'https://',
  'configuration-page.urls.callback-urls.input.add-button': '添加URL',
  "configuration-page.urls.callback-urls.notification": "确保列出所有可能在 OAuth 授权过程中用作重定向的 URL。<br></br><br></br> 1. 使用完整格式：协议 + 域名 + 路径。例如：https://domain.com/auth<br></br> 2. 包括所有子域名变体，例如：https://domain.com/auth 和 https://www.domain.com/auth<br></br> 3. 如果应用可能使用 https:// 和 http://，请明确列出两个版本。<br></br> 4. 注意尾部斜杠。如果可能访问 /auth 和 /auth/，请都包含。<br></br> 5. 忽略查询参数和片段 — 不要添加如 ?code=... 或 #section。<br></br><br></br> 如果重定向 URL 不在列表中，用户将无法完成登录流程。",

  'configuration-page.urls.allowed-origin.title': '允许的来源(CORS)',
  'configuration-page.urls.allowed-origin.description': '允许向艾克索拉API（一般配合CORS使用）发起跨源HTTP请求的URL集。这样可以防止在网页浏览器中使用艾克索拉产品和服务时的同源政策错误。',
  'configuration-page.urls.allowed-origin.notification': '此字段用于指定来源（如需要）。您可以指定多个有效URL。',
  'configuration-page.urls.allowed-origin.input.title': '允许的来源(CORS)',
  'configuration-page.urls.allowed-origin.input.placeholder': 'https://',
  'configuration-page.urls.allowed-origin.input.add-button': '添加URL',

  'configuration-page.urls.error-callback.title': '错误回调URL',
  'configuration-page.urls.error-callback.description': '发生登录错误时将用户重定向到的错误回调URL。',
  'configuration-page.urls.error-callback.notification': '如未指定任何值，则使用回调URL。',
  'configuration-page.urls.error-callback.input.title': '错误回调URL',
  'configuration-page.urls.error-callback.input.placeholder': 'https://',
  'configuration-page.urls.error-callback.input.add-button': '添加URL',
  'configuration-page.urls.default-callback.title': '默认回调 URL',
  'configuration-page.urls.default-callback.description': '使用者被重新導向的預設回呼 URL。',
  'configuration-page.urls.default-callback.notification': '請輸入下方回呼 URL 清單中的一個。',

  'configuration-page.urls.allow-logout.title': '允许的注销URL',
  'configuration-page.urls.allow-logout.description': '用户注销登录管理器时用于重定向的有效URL。您可以用(returnTo)查询参数来重定向用户。',
  'configuration-page.urls.allow-logout.notification': '如未指定任何值，则使用回调URL。',
  'configuration-page.urls.allow-logout.input.title': '允许的注销URL',
  'configuration-page.urls.allow-logout.input.placeholder': 'https://',
  'configuration-page.urls.allow-logout.input.add-button': '添加URL',

  'configuration-page.sign-up.page-title': '注册设置',
  'configuration-page.sign-up.page-description': '您可以通过这些设置管理用户注册。',
  'configuration-page.sign-up.page-notification': '本选项用于管理使用用户名和密码或邮箱和密码对进行的用户注册。如要管理使用社交网络进行的注册，请前往<a>社交网络设置</a>。',
  'configuration-page.sign-up.disable-sign-up.title': '用户注册',
  'configuration-page.sign-up.disable-sign-up.description': '如将此开关设置为“开”，则用户可以注册。',
  'configuration-page.sign-up.welcome-email.title': '启用注册欢迎电子邮件',
  'configuration-page.sign-up.welcome-email.description': '如果此切换设置为开启，用户将能够在注册时收到欢迎电子邮件。',


  'configuration-page.password.page-title': '密码设置',
  'configuration-page.password.page-description': '密码强度是使用密码进行认证的一项重要考量。',
  'configuration-page.password.page-notification': '强密码政策可以让人难以甚至不可能通过人为或自动的方法猜出密码。',
  'configuration-page.password.miscellaneous.title': '杂项密码设置',
  'configuration-page.password.miscellaneous.description': '允许支持以下安全条件的密码。',
  'configuration-page.password.miscellaneous.notification': '此为一组推荐设置，它们互为补充以帮助建立更稳健的密码解决方案。',
  'configuration-page.password.miscellaneous.recover-pass.title': '找回密码',
  'configuration-page.password.miscellaneous.recover-pass.description': '允许用户找回丢失的密码。',
  'configuration-page.password.miscellaneous.pass-history.title': '密码历史记录',
  'configuration-page.password.miscellaneous.pass-history.description': '保存每个用户的密码历史记录，防止使用之前用过的密码。',
  'configuration-page.password.miscellaneous.pass-check.title': '密码检查',
  'configuration-page.password.miscellaneous.pass-check.description': '要求用户在注册时重复输入密码。',
  'configuration-page.password.password-reset-cb-url.title': '选择密码重置回调URL',
  'configuration-page.password.password-reset-cb-url.description': '选择一个用户重置密码后将其重定向到的URL地址。',
  'configuration-page.password.password-reset-cb-url.placeholder': '选择URL',
  'configuration-page.password.password-validation.toggle-box.title': '密码验证',
  'configuration-page.password.password-validation.toggle-box.description': '选择用于密码验证的规则。',
  'configuration-page.password.password-validation.tests.title': '测试密码',
  'configuration-page.password.password-validation.tests.description': '输入密码进行检查：',
  'configuration-page.password.password-validation.tests.input-title': '密码',
  'configuration-page.password.status.absent': '无保护力',
  'configuration-page.password.status.weak': '弱密码',
  'configuration-page.password.status.good': '好密码',
  'configuration-page.password.status.strong': '强密码',
  'configuration-page.username.page-title': '用户名设置',
  'configuration-page.username.page-description': '通过这些设置建立主要登录流程。',
  'configuration-page.username.page-notification': '要使用此设置，请启用以下选项：<ul><li>通过用户名和密码注册</li><li>通过用户名和密码登录</li></ul>',
  'configuration-page.username.requires.title': '要求用户名',
  'configuration-page.username.requires.description': '除邮箱地址外还要求用户提供用户名。',
  'configuration-page.username.username-validation.title': '用户名验证',
  'configuration-page.username.username-validation.description': '自定义字段验证仅适用于用户名字段。',
  'configuration-page.username.username-validation.notification': '用户名验证最多可设置4条规则，也可以不设置验证规则。',
  'configuration-page.username.username-validation.toggle-box.title': '用户名验证',
  'configuration-page.username.username-validation.toggle-box.description': '选择用于用户名验证的规则。',
  'configuration-page.username.username-validation.tests.title': '测试用户名',
  'configuration-page.username.username-validation.tests.description': '输入用户名进行检查：',
  'configuration-page.username.username-validation.tests.input-title': '用户名',
  'configuration-page.username.username-validation.tests.username-email': '使用用戶名作為電子郵件',

  'configuration-page.validation-rule.min_characters': '长度必须至少为{number}个字符',
  'configuration-page.validation-rule.max_characters': '长度不得超过{number}个字符',
  'configuration-page.validation-rule.user_numerals_spec_symbol': '必须包含数字、连字符或下划线',
  'configuration-page.validation-rule.letter_case': '必须为大小写字母的组合',
  'configuration-page.validation-rule.numerals': '必须至少包含一个数字(0-9)',
  'configuration-page.validation-rule.spec_characters': '必须至少包含1个特殊字符',
  'configuration-page.validation-rule.allow_ascii_characters': '必须仅包含ASCII字符',
  'configuration-page.validation-rule.exclude_personal_data': '不得包含个人数据',
  'configuration-page.validation-rule.password_dictionary': '不得包含密码<a>字典</a>中的字符串',

  /* settings.email-validation встречается при классической авторизации и passwordless.
    На двух макетах: https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600
    https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A76750
  */
  'settings.email-validation.title': '邮箱验证',
  'settings.email-validation.subtitle': '可通过邮箱验证检查用户邮箱地址的真实性。',
  'settings.email-validation.notification.label': '您可以启用一个或多个条件来验证邮箱地址。',
  'settings.email-validation.smtp.switch.title': 'SMTP验证',
  'settings.email-validation.smtp.switch.caption': "显示收件人邮箱是否真实存在的收件人服务器连接。",
  'settings.email-validation.rfc.switch.title': 'RFC验证',
  'settings.email-validation.rfc.switch.caption': '决定邮箱地址可以接受哪些字符的规范。',
  'settings.email-validation.gray-list.switch.title': '拦截列表验证',
  'settings.email-validation.gray-list.switch.caption': '永久拦截垃圾邮件域名并拒绝接收来自这些域名的邮件。如要添加或删除该列表中的邮件域名，请与我们联系。',
  'settings.email-validation.confirmation.switch.title': '发送验证邮件',
  'settings.email-validation.confirmation.switch.caption': "发送验证邮件以验证用户。",

  'settings.email-settings.title': '邮件设置',
  'settings.email-settings.subtitle': '通过这些设置建立主要登录流程。',
  'settings.email-settings.magic-link.title': '神奇链接',
  'settings.email-settings.magic-link.subtitle': '用户将收到一封包含该链接的邮件并通过点击链接进行登录。',
  'settings.email-settings.magic-link.switch.title': '通过神奇链接登录',
  'settings.email-settings.magic-link.switch.caption': '允许用户在点击链接后登录。',

  'settings.crumbs.login-type.passwordless-login': '免密登录',
  'settings.tabs.email-settings': '邮件设置',
  'settings.tabs.passwordless-settings': '设置',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A79600 */
  'settings.passwordless.change-method.description': '让用户在无需输入密码的情况下通过邮箱地址或手机号码进行登录。',
  'settings.passwordless.change-method.notification': '请选择要使用的免密认证方式：',
  'settings.passwordless.change-method.phone.label': '通过手机号免密登录',
  'settings.passwordless.change-method.phone.description': '让用户通过手机号和验证码登录。',
  'settings.passwordless.change-method.email.label': '通过邮箱地址免密登录',
  'settings.passwordless.change-method.email.description': '让用户通过邮箱地址和验证码进行注册和登录。',
  'settings.passwordless.change-method.phoneEmail.label': '通过手机号和邮箱地址免密登录',
  'settings.passwordless.change-method.phoneEmail.description': '让用户通过手机号和邮箱地址以及验证码进行注册和登录。',

  'secure.oauth2.tab': 'OAuth 2.0',
  'secure.signature.tab': 'JWT签名',
  'secure.mfa.tab': 'MFA政策',
  'authorization.settings.oauth2.client.title': 'OAuth 2.0客户端',
  'authorization.settings.oauth2.client.subtitle': 'OAuth 2.0相当于一个授权层，将客户端角色与资源所有者分开。',
  'authorization.settings.oauth2.notification': '<b>如何获取客户端ID和客户端密钥</b><br></br> 1. 添加OAuth 2.0认证。<br></br> 2. 指定客户端名称和OAuth 2.0重定向URI。<br></br> 3. 指定认证类型：公开或机密。<br></br><br></br> <a>请参阅文档</a>了解OAuth 2.0的详细信息。',
  'authorization.settings.oauth2.add': '添加OAuth 2.0客户端',
  'authorization.settings.oauth2.server.title': 'OAuth 2.0服务器',
  'authorization.settings.oauth2.server.name.title': '客户端名称',
  'authorization.settings.oauth2.server.name.placeholder': 'OAuth 2.0认证',
  'authorization.settings.oauth2.server.secret-key.title': '密钥',
  'authorization.settings.oauth2.server.secret-key.extra': '重置密钥',
  'authorization.settings.oauth2.server.subtitle': 'OAuth 2.0相当于一个授权层，将客户端角色与资源所有者分开。',
  'authorization.settings.oauth2.table.client-name': '客户端名称',
  'authorization.settings.oauth2.table.client-id': '客户端ID',
  'authorization.settings.oauth2.table.client-secret': '密钥',
  'authorization.settings.oauth2.table.auth-type': '认证类型',
  'authorization.settings.oauth2.table.copy': '复制密钥',
  'authorization.settings.oauth2.table.empty.title': '尚无OAuth 2.0客户端',
  'authorization.settings.oauth2.table.empty.text': '所有添加的OAuth 2.0客户端将在此处显示。',
  'authorization.settings.oauth2.modal.connect.button': '连接',
  'authorization.settings.oauth2.modal.connect.title': 'OAuth 2.0认证',
  'authorization.settings.oauth2.modal.connect.instruction.title': '如何设置OAuth 2.0认证',
  'authorization.settings.oauth2.modal.connect.instruction': '1. 复制您的客户端ID和密钥<br></br> 2. 通过<a>小组件</a>或<c>API方法</c>更新您的项目集成',
  'authorization.settings.oauth2.modal.connect.redirect-uri.title': 'OAuth 2.0重定向URI',
  'authorization.settings.oauth2.modal.connect.redirect-uri.placeholder': 'https://example.com',
  'authorization.settings.oauth2.validation.invalid-url': '无效的URL',
  'authorization.settings.oauth2.validation.duplicate-url': '重复的URL',
  'authorization.settings.oauth2.modal.connect.type.public': '公开<span>（建议用于应用程序）</span>',
  'authorization.settings.oauth2.modal.connect.type.private': '机密<span>（建议用于服务器对服务器连接）</span>',
  'authorization.settings.oauth2.modal.connect.success.title': '已成功连接OAuth 2.0认证',
  'authorization.settings.oauth2.modal.connect.success.subtitle': '复制此客户端ID和密钥用于项目集成。',
  'authorization.settings.oauth2.modal.connect.success.client-id': '客户端ID',
  'authorization.settings.oauth2.modal.connect.success.more-title.title': '接下来',
  'authorization.settings.oauth2.modal.connect.success.more-title': '如何集成OAuth 2.0认证',
  'authorization.settings.oauth2.modal.connect.success.dismiss': '关闭',
  'authorization.settings.oauth2.modal.connect.update.remove': '删除OAuth 2.0客户端',
  'authorization.settings.oauth2.modal.connect.update.remove.subtitle': '无法恢复删除的OAuth 2.0客户端。',
  'authorization.settings.oauth2.modal.remove.title': '是否删除{name}OAuth 2.0客户端？',
  'authorization.settings.oauth2.modal.remove.subtitle': '配置其他认证方法之前连接的所有URl无法进行用户认证。',
  'authorization.settings.oauth2.modal.remove.checkbox': '好，知道了',
  'authorization.settings.oauth2.modal.remove.submit': '是，删除',
  'authorization.settings.oauth2.table.client-key': '客户端密钥',
  'authorization.settings.oauth2.table.server-key': '服务器密钥',
  'authorization.settings.oauth2.modal.connect.type.server': '服务器<span>（服务器对服务器连接）</span>',
  'authorization.settings.oauth2.modal.connect.merchant-project.label': '项目ID',
  'authorization.settings.oauth2.modal.connect.type.server.description': '相当于一个授权层，将客户端角色与资源所有者分开。',
  'authorization.settings.oauth2.modal.connect.type.confidential.description': '客户端需要密钥才能发起登录。',
  'authorization.settings.oauth2.modal.connect.type.public.description': '客户端不需要使用密钥。',

  'authorization.settings.babkaLogin.modal.connect.title': '新建OAuth 2.0客户端',
  'authorization.settings.babkaLogin.modal.connect.scope.title': 'Scope',
  'authorization.settings.babkaLogin.modal.connect.scope.placeholder': '新建作用域',
  'authorization.settings.babkaLogin.modal.connect.audience.title': 'Audience',
  'authorization.settings.babkaLogin.client.name': '艾克索拉OAuth 2.0客户端',
  'authorization.settings.babkaLogin.field.logo-url.title': '应用程序图标',
  'authorization.settings.babkaLogin.field.logo-url.tooltip': '推荐图片分辨率：{sizePx}x{sizePx}{br}支持的格式：JPG和PNG{br}最大大小：{sizeKb} KB',
  "authorization.settings.babkaLogin.field.logo-url.upload-error": "无法上传图片。请重试。",
  "authorization.settings.babkaLogin.field.logo-url.size-error": "图片大小应小于{size}KB",
  "authorization.settings.babkaLogin.info.displayed-details": "当玩家使用艾克索拉ID登录您的应用或游戏时，您的应用图标、名称和描述将显示在玩家的艾克索拉钱包帐户中",
  'authorization.settings.babkaLogin.field.name.label': '应用程序名称',
  'authorization.settings.babkaLogin.field.description.label': '简短描述',
  'authorization.settings.babkaLogin.scopes.add-button': '新建作用域',
  'authorization.settings.babkaLogin.field.scope.regex-error': '仅可使用英文字母、英文句点或下划线，且不能以英文句点或下划线开头或结尾',

  'social-connection.title': '社交网络',
  'social-connection.subtitle': '让用户可以通过自己选择的身份信息提供商一键登录您的应用。',
  'social-connection.tabs.social-connection-path': '社交网络',
  'social-connection.tabs.enterprise-connection-path': 'OAuth 2.0登录连接',
  'social-connection.tabs.passkey': '通行密钥',
  'social-connection.tabs.miscellaneous': '补充表单',
  'social-connection.tabs.api-settings': 'Login API集成',
  'social-connection.select.deselect': '取消选择',
  'social-connection.select.select': '全选',
  'social-connection.select.all': '全部社交网络',
  'social-connection.select.connected': '已连接',
  'social-connection.select.disconnected': '已断开连接',
  'social-connection.search.placeholder': '搜索...',
  'social-connection.mode.title': '管理',
  'social-connection.mode.connect': '连接',
  'social-connection.mode.disconnect': '断开连接',
  'social-connection.card.tooltip': '可以配合艾克索拉密钥使用',
  'social-connection.card.subscription.subtitle': '允许用户注册及登录您的应用',
  'social-connection.card.settings.connect': '连接',
  'social-connection.card.settings.disconnect': '断开连接',
  'social-connection.card.settings.settings': '设置',
  'social-connection.card.settings.try': '尝试连接',
  'social-connection.babka-disconnect.title': '断开艾克索拉帐户',
  'social-connection.babka-disconnect.description': '断开后，用户将自动迁移至艾克索拉ID，艾克索拉帐户选项将不再显示。撤销此操作需联系技术支持。',
  'social-connection.card.status.connected': '已连接',
  'social-connection.card.status.disconnected': '已断开连接',
  'social-connection.card.button.show-more': '显示全部',
  'social-connection.card.button.show-less': '显示更少',
  'social-connection.jwt.title': '嵌入社交网络JWT令牌',
  'social-connection.jwt.subtitle': '自动在艾克索拉登录管理器JWT令牌中嵌入一个社交网络JWT令牌。',
  'social-connection.jwt.notification': '社交网络JWT令牌可能用于直接访问社交网络API。',

  'social-connection.settings.subtitle': '按照以下步骤连接此社交网络。',
  'social-connection.settings.notification': "如使用自己的应用程序：<br></br> 1. 前往该社交网络的开发者帐户。<br></br> 2. 将{link}添加为允许的重定向URI。<br></br><br></br> 注：如使用艾克索拉应用程序来进行社交网络认证，则无需完成上述设置。",
  'social-connection.settings.sync.notification': '默认情况下，登录管理器会自动根据每次用户登录同步用户资料数据。',
  'social-connection.settings.back-button': '返回<b>社交网络</b>',
  'social-connection.settings.sync.switch.title': '每次登录后同步用户资料属性',
  'social-connection.settings.sync.switch.subtitle': '您也可以选择禁用用户资料数据同步，而从您的应用程序来更新资料属性。',
  'social-connection.settings.app-id.notification': '如何获取应用程序ID',
  'social-connection.settings.one-tap.title': '{name}一键登录',
  'social-connection.settings.one-tap.subtitle': '让用户通过其{name}帐户登录而无需打开单独登录窗口。',
  'social-connection.settings.field.client_id.label': '应用程序ID',
  'social-connection.settings.field.client_id.placeholder': '留空则使用艾克索拉ID',
  'social-connection.settings.field.client_secret.label': '应用程序密钥',
  'social-connection.settings.field.client_secret.placeholder': '留空则使用艾克索拉密钥',
  'social-connection.settings.field.client_secret.footer': '出于安全性考虑，不显示您使用的应用程序密钥。',
  'social-connection.settings.field.client_secret.file': '上传的文件',
  'social-connection.settings.field.custom_return_url.label': '自定义Return URL',
  'social-connection.settings.field.custom_return_url.placeholder': '留空则使用艾克索拉Return URL',
  'social-connection.settings.field.team_id.label': 'Team ID',
  'social-connection.settings.field.team_id.placeholder': '留空则使用艾克索拉Team ID',
  'social-connection.settings.field.key_id.label': 'Key ID',
  'social-connection.settings.field.key_id.placeholder': '留空则使用艾克索拉Key ID',
  'social-connection.settings.scopes-disabled.notification': '要收集勾选的用户数据或应用勾选的社交网络权限，需用到您自己的社交网络应用程序。为此，请填写上面的应用程序ID和应用程序密钥字段。',
  'social-connection.settings.user-data.title': '用户数据',
  'social-connection.settings.user-data.subtitle': '提供下方勾选的用户资料数据的访问权限。{name}将显示相应的同意消息。',
  'social-connection.settings.permission.title': '权限',
  'social-connection.settings.permission.subtitle': '登录管理器将对每个勾选的权限向{name}请求权限，以便可以使用access_token从您的应用程序调用{name} API。',
  'social-connection.settings.permission.notification': '<a>详细信息请参阅{name}文档</a>。',
  'social-connection.settings.field.url_authorize.label': '授权URL',
  'social-connection.settings.field.url_access_token.label': '访问令牌URL',
  'social-connection.subtitle.custom-social': "您已启用自定义OAuth 2.0登录连接。<a>打开OAuth 2.0登录连接页面。</a>",

  /* Custom social fields */
  'social-connection.settings.apple.app-id.notification': '如何获取Service ID',
  'social-connection.settings.apple.app-id.notification': '如何获取Service ID',
  'social-connection.settings.babka.app-id.notification': '如果您的艾克索拉帐户未激活，请<a>按照指南进行操作</a>。',
  'social-connection.settings.field.apple.client_id.label': 'Service ID',
  'social-connection.settings.field.apple.client_id.placeholder': '留空则使用艾克索拉Service ID',
  'social-connection.settings.field.apple.client_secret.label': 'Auth Key',
  'social-connection.settings.field.apple.client_secret.placeholder': '留空则使用艾克索拉密钥',
  'social-connection.settings.field.apple.client_secret.file': '密钥文件',
  'social-connection.settings.field.babka.audience.label': '您的网站链接',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=2454%3A77981 */
  'settings.tabs.platform-settings': '发布平台',
  'settings.platform-settings.connect': '连接',
  'settings.platform-settings.update': '应用',
  'settings.platform-settings.select.all': '所有发布平台',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=745%3A38333 */
  'custom-providers.settings.email.title': '邮件服务提供商',
  'custom-providers.settings.email.subtitle': '您可以配置邮件服务提供商来自行管理、监控您的邮件通信以及排查问题。',
  'custom-providers.settings.email.notification': '<a>在邮件自定义页面自定义您的邮件。</a>您也可以将艾克索拉邮件模板用作默认邮件。',
  'custom-providers.settings.email.settings.label': '发件人设置',
  'custom-providers.settings.email.settings.description': '您可以自行指定发件人名称和邮箱地址。如未指定，收件人看到的是您登录管理器项目默认的发件人名称和邮箱地址。',
  'custom-providers.settings.email.from_email.label': '发件人邮箱地址',
  'custom-providers.settings.email.from_email.placeholder': 'noreply@login.xsolla.com',
  'custom-providers.settings.email.from_email.footer': '该邮箱地址是收件人收到您的邮件时看到的名称。',
  'custom-providers.settings.email.from_name.label': '发件人名称',
  'custom-providers.settings.email.from_name.footer': '该名称是收件人收到您的邮件时看到的名称。',
  'custom-providers.settings.email.provider.notification': '默认提供商为SendGrid。您的SendGrid API密钥在艾克索拉数据库中始终保持加密。',
  'custom-providers.settings.email.provider.send-grid': 'SendGrid',
  'custom-providers.settings.email.provider.send-grid.label': '提供商设置',
  'custom-providers.settings.email.provider.send-grid.description': '注册SendGrid帐户并获取<a>API密钥</a>。',
  'custom-providers.settings.email.provider.send-grid.api-key.label': 'API密钥',
  'custom-providers.settings.email.provider.send-grid.api-key.placeholder': 'SendGrid API密钥',
  'custom-providers.settings.email.provider.smtp': '自定义（即将上线）',
  'custom-providers.settings.email.provider.smtp.label': '提供商设置',
  'custom-providers.settings.email.provider.smtp.description': '您的SMTP凭证在我们的数据库中将始终保持加密。请保存您的设置并使用“发送测试邮件”按钮来测试连接。<a>更多信息请查看我们的说明</a>。',
  'custom-providers.settings.email.provider.smtp.notification': 'SMTP服务器要求：<ul><li>必须支持用户名和密码认证</li><li>必须支持TLS 1.0或更高版本</li></ul>',
  'custom-providers.settings.email.provider.smtp.host.label': '主机',
  'custom-providers.settings.email.provider.smtp.host.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.email.provider.smtp.host.sublabel': 'SMTP服务器的主机名或IP地址',
  'custom-providers.settings.email.provider.smtp.port.label': '端口',
  'custom-providers.settings.email.provider.smtp.port.placeholder': '587',
  'custom-providers.settings.email.provider.smtp.port.sublabel': 'SMTP服务器使用的端口。常用端口为25、465和587。<br></br>如可能，请避免使用端口25，因为许多提供商对该端口有限制',
  'custom-providers.settings.email.provider.smtp.username.label': '用户名',
  'custom-providers.settings.email.provider.smtp.username.placeholder': '自定义提供商用户名',
  'custom-providers.settings.email.provider.smtp.password.label': '密码',
  'custom-providers.settings.email.provider.smtp.password.placeholder': '自定义提供商密码',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A87099 */
  'miscellaneous.settings.title': '补充数据表单',
  'miscellaneous.settings.subtitle': '如果注册过程中未提供必需数据，可使用补充表单获取。数据表单作为一种额外验证可帮助用户成功完成身份认证。这些表单用于验证收集到的邮箱地址和/或手机号码。',
  'miscellaneous.settings.email.title': '邮箱地址表单',
  'miscellaneous.settings.email.subtitle': '如果注册过程中未提供必需数据或提供了通过社交网络进行认证的方式，则邮箱地址表单用作补充表单。',
  'miscellaneous.settings.email.collect-data.title': '收集用户邮箱地址',
  'miscellaneous.settings.email.collect-data.subtitle': '通过邮件发送给用户的验证码或链接验证收集到的邮箱地址。',
  'miscellaneous.settings.email.required.title': '要求用户完成邮箱表单',
  'miscellaneous.settings.email.required.subtitle': '如果开关设置为开，则要求用户填写额外信息收集表单。如设置为关，则用户可以跳过该表单。',
  'miscellaneous.settings.email.confirmation.title': '邮箱地址验证方法',
  'miscellaneous.settings.email.confirmation.code.title': '通过验证码',
  'miscellaneous.settings.email.confirmation.code.description': '通过发送给用户的验证码进行验证。',
  'miscellaneous.settings.email.confirmation.link.title': '通过验证码和链接',
  'miscellaneous.settings.email.confirmation.link.description': '通过邮件发送给用户的验证码和链接进行验证。',
  'miscellaneous.settings.email.confirmation.link-only.title': '通过链接',
  'miscellaneous.settings.email.confirmation.link-only.description': '通过发送给用户的邮件中的链接进行验证。',
  'miscellaneous.settings.phone_number.title': '手机号码表单',
  'miscellaneous.settings.phone_number.subtitle': '如果注册过程中未提供必需数据或提供了通过社交网络进行认证的方式，则手机号码表单用作补充表单。',
  'miscellaneous.settings.phone_number.collect-data.title': '收集用户手机号码',
  'miscellaneous.settings.phone_number.collect-data.subtitle': '通过短信验证码验证收集到的手机号码。',
  'miscellaneous.settings.phone_number.required.title': '要求用户完成手机号码',
  'miscellaneous.settings.phone_number.required.subtitle': '如果开关设置为开，则要求用户填写额外信息收集表单。如设置为关，则用户可以跳过该表单。',
  'miscellaneous.settings.order.title': '表单顺序',
  'miscellaneous.settings.order.subtitle': '验证表单以所选顺序对用户显示。',
  'miscellaneous.settings.order.notification': '要使用此选项，需同时启用邮箱地址和手机号码表单。',
  'miscellaneous.settings.order.email': '先显示邮箱表单',
  'miscellaneous.settings.order.phone': '先显示手机号码表单',

  'api-settings.title': 'Login API集成',
  'api-settings.subtitle': '通过Login API配置集成。',
  'api-settings.device-id.title': '使用设备ID登录',
  'api-settings.device-id.subtitle': '通过<a>API调用</a>允许用户使用设备ID登录。',

  'auth-methods.login_pass_auth': '电子邮箱/密码',
  'auth-methods.email_auth': '通过邮箱免密登录',
  'auth-methods.phone_auth': '通过手机免密登录',
  'auth-methods.telegram': 'Telegram',
  'auth-methods.other': '其他',
  'auth-methods.google': 'Google',
  'auth-methods.abyss': 'The Abyss',
  'auth-methods.apple': 'Apple',
  'auth-methods.epicgames': 'Epic Games',
  'auth-methods.amazon': 'Amazon',
  'auth-methods.babka': '艾克索拉',
  'auth-methods.baidu': '百度',
  'auth-methods.battlenet': 'Battle.net',
  'auth-methods.china_telecom': '中国电信',
  'auth-methods.discord': 'Discord',
  'auth-methods.facebook': 'Facebook',
  'auth-methods.github': 'GitHub',
  'auth-methods.google-plus': 'Google+',
  'auth-methods.instagram': 'Instagram',
  'auth-methods.kabam': 'Kabam',
  'auth-methods.kakao': 'KakaoTalk',
  'auth-methods.linkedin': 'LinkedIn',
  'auth-methods.mailru': 'Mail.Ru',
  'auth-methods.microsoft': 'Microsoft帐户',
  'auth-methods.msn': 'MSN',
  'auth-methods.naver': 'Naver',
  'auth-methods.ok': 'OK',
  'auth-methods.paradox': 'Paradox',
  'auth-methods.paypal': 'PayPal',
  'auth-methods.pinterest': 'Pinterest',
  'auth-methods.playfab': 'PlayFab',
  'auth-methods.wbgames': 'Player Network',
  'auth-methods.qq': 'QQ',
  'auth-methods.reddit': 'Reddit',
  'auth-methods.steam': 'Steam',
  'auth-methods.stone': 'Stone',
  'auth-methods.twitch': 'Twitch',
  'auth-methods.twitter': 'X',
  'auth-methods.vimeo': 'Vimeo',
  'auth-methods.vk': 'VK',
  'auth-methods.wechat': '微信',
  'auth-methods.weibo': '微博',
  'auth-methods.xbox': 'Xbox Live',
  'auth-methods.xsolla-id': 'Xsolla',
  'auth-methods.yahoo': 'Yahoo',
  'auth-methods.yandex': 'Yandex',
  'auth-methods.youtube': 'YouTube',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A86451 */
  'enterprise-connection.settings.title': 'OAuth 2.0登录连接',
  'enterprise-connection.settings.subtitle': '通过OAuth 2.0将您的授权界面关联至艾克索拉，让用户通过它进行登录',
  'enterprise-connection.settings.notification': '要使用OAuth登录连接，请完成下方字段。如需帮助，<a>请联系您的客户成功经理</a>。',
  'enterprise-connection.settings.integration-name.label': '授权名称',
  'enterprise-connection.settings.integration-name.tooltip': '用于在艾克索拉登录管理器中识别OAuth 2.0集成',
  'enterprise-connection.settings.integration-name.placeholder': 'xsolla-oauth2',
  'enterprise-connection.settings.authorization-endpoint.label': '授权URL',
  'enterprise-connection.settings.authorization-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.authorization-endpoint.tooltip': '授权服务器端点的URL，用户跳转到该地址进行认证和访问',
  'enterprise-connection.settings.token-endpoint.label': '令牌URL',
  'enterprise-connection.settings.token-endpoint.placeholder': 'https://example.com',
  'enterprise-connection.settings.token-endpoint.tooltip': '授权服务器令牌端点的URL，认证成功后从该地址获取访问令牌',
  'enterprise-connection.settings.url_resource_owner_details.label': '您的信息URL',
  'enterprise-connection.settings.url_resource_owner_details.placeholder': 'https://example.com',
  'enterprise-connection.settings.url_resource_owner_details.tooltip': '授权服务器用户信息端点',
  'enterprise-connection.settings.client-id.label': '客户端ID',
  'enterprise-connection.settings.client-id.placeholder': '1234',
  'enterprise-connection.settings.client-id.tooltip': '您的授权系统创建的唯一ID\n',
  'enterprise-connection.settings.client-secret.label': '客户端密钥',
  'enterprise-connection.settings.client-secret.placeholder': '123a12b1234ab1234a1ab1234abc1234',
  'enterprise-connection.settings.client-secret.tooltip': '由您的授权服务器提供',
  'enterprise-connection.settings.scope.label': '权限范围',
  'enterprise-connection.settings.scope.placeholder': '例如email、offline等',
  'enterprise-connection.settings.map.title': '键名映射',
  'enterprise-connection.settings.map.description': '输入令牌 URL 中的用户属性键，以便与 Xsolla Login 同步数据',
  'enterprise-connection.settings.map.notification': '在右侧字段中输入键名。它们将映射至左侧相应字段。',
  'enterprise-connection.settings.delete': '删除登录连接',
  'enterprise-connection.settings.map.email.placeholder': "令牌中的邮箱键名",
  'enterprise-connection.settings.map.id.placeholder': "令牌中的ID键名",
  "enterprise-connection.settings.customization.title": "自定义",
  "enterprise-connection.settings.customization.subtitle": "设置登录管理器小组件中的授权按钮显示",
  "enterprise-connection.settings.customization.display_name.label": "授权按钮名称",
  "enterprise-connection.settings.customization.display_name.tooltip": "此名称对用户显示",
  "enterprise-connection.settings.customization.background_color.label": "授权按钮颜色",
  "enterprise-connection.settings.customization.logo_url.label": "Logo",
  "enterprise-connection.settings.customization.logo_url.footer": "建议尺寸：24px × 24px{newLine}支持的格式：JPG、PNG和SVG",

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=6751%3A97166 */
  'custom-providers.bread-crumbs.label': '通讯服务提供商',
  'custom-providers.tabs.email': '邮件服务提供商',
  'custom-providers.tabs.sms': '短信服务提供商',
  'custom-providers.tabs.send-sms.button': '发送测试短信',
  'custom-providers.tabs.send-email.button': '发送测试邮件',

  'custom-providers.settings.sms.title': '短信服务提供商',
  'custom-providers.settings.sms.fields-group.active': '已激活',
  'custom-providers.settings.sms.fields-group.inactive': '未激活',
  'custom-providers.settings.sms.fields-group.list-item.activate': '激活提供商',
  'custom-providers.settings.sms.fields-group.list-item.deactivate': '停用提供商',
  'custom-providers.settings.sms.subtitle': '您可以配置短信提供商以使用包含验证码的短信作为认证方式。',
  'custom-providers.settings.sms.notification': '默认情况下，您可以使用Amazon SNS、Twilio、Sinch、Telnyx、SMSCENTER和Alibaba Cloud作为短信提供商。您可以使用多家提供商以及单独激活或停用提供商。如果激活了多个提供商，我们会根据各个国家/地区使用最合适的一个。',
  'custom-providers.settings.sms.msp.read-more': '<a>了解短信服务价格的更多信息。</a>',
  'custom-providers.settings.sms.provider.sender-id.label': '发送人ID',
  'custom-providers.settings.sms.provider.sender-id.placeholder': 'your.smtp.host.com',
  'custom-providers.settings.sms.provider.sender-id.sublabel': '<a>可以识别短信发送人的名称（英文字母）</a>',
  'custom-providers.settings.sms.provider.amazon': 'Amazon SNS',
  'custom-providers.settings.sms.provider.amazon.label': 'Amazon SNS设置',
  'custom-providers.settings.sms.provider.amazon.description': '注册Amazon帐户，然后通过验证域名并请求生产访问权限来<a>配置Amazon SNS</a>。',
  'custom-providers.settings.sms.provider.amazon.phone.label': 'Amazon SNS电话号码',
  'custom-providers.settings.sms.provider.amazon.key-id.label': '访问密钥ID',
  'custom-providers.settings.sms.provider.amazon.access-key.label': '秘密访问密钥',
  'custom-providers.settings.sms.provider.amazon.region.label': '区域',
  'custom-providers.settings.sms.provider.amazon.region.sublabel': '<a>您的AWS SNS区域</a>',
  'custom-providers.settings.sms.provider.twilio': 'Twilio',
  'custom-providers.settings.sms.provider.twilio.label': 'Twilio设置',
  'custom-providers.settings.sms.provider.twilio.description': '注册Twilio帐户并<a>配置Programmable Messaging API</a>。',
  'custom-providers.settings.sms.provider.twilio.sid.label': 'Twilio SID',
  'custom-providers.settings.sms.provider.twilio.sid.sublabel': '<a>了解Twilio SID的详细信息</a>',
  'custom-providers.settings.sms.provider.twilio.auth-token.label': 'Twilio认证令牌',
  'custom-providers.settings.sms.provider.twilio.auth-token.sublabel': '<a>了解Twilio认证令牌的详细信息</a>',
  'custom-providers.settings.sms.provider.twilio.phone.label': 'Twilio电话号码',
  'custom-providers.settings.sms.provider.sinch': 'Sinch',
  'custom-providers.settings.sms.provider.sinch.label': 'Sinch设置',
  'custom-providers.settings.sms.provider.sinch.description': '注册Sinch帐户并<a>配置SMS messaging API</a>。',
  'custom-providers.settings.sms.provider.sinch.plan-id.label': 'Sinch服务计划ID',
  'custom-providers.settings.sms.provider.sinch.plan-id.sublabel': '<a>了解Sinch服务计划ID的更多信息</a>',
  'custom-providers.settings.sms.provider.sinch.auth-token.label': 'Sinch API令牌',
  'custom-providers.settings.sms.provider.sinch.phone.label': 'Sinch电话号码',
  'custom-providers.settings.sms.provider.telnyx': 'Telnyx',
  'custom-providers.settings.sms.provider.telnyx.label': 'Telnyx设置',
  'custom-providers.settings.sms.provider.telnyx.description': '注册Telnyx帐户并<a>配置SMS API</a>。',
  'custom-providers.settings.sms.provider.telnyx.app-id.label': 'Telnyx Messaging Profile ID',
  'custom-providers.settings.sms.provider.telnyx.api-key.label': 'Telnyx API密钥',
  'custom-providers.settings.sms.provider.telnyx.phone.label': 'Telnyx电话号码',
  'custom-providers.settings.sms.provider.smscenter': 'SMSCENTER',
  'custom-providers.settings.sms.provider.smscenter.label': 'SMSCENTER设置',
  'custom-providers.settings.sms.provider.smscenter.description': '注册SMSCENTER并<a>配置SMS API</a>。',
  'custom-providers.settings.sms.provider.smscenter.app-id.label': 'SMSCENTER用户名',
  'custom-providers.settings.sms.provider.smscenter.app-secret.label': 'SMSCENTER密码',
  'custom-providers.settings.sms.provider.smscenter.sender-id.label': '发件人名称',
  'custom-providers.settings.sms.provider.alibaba': 'Alibaba Cloud',
  'custom-providers.settings.sms.provider.alibaba.label': 'Alibaba Cloud设置',
  'custom-providers.settings.sms.provider.alibaba.description': '注册Alibaba Cloud并<a>配置SMS API</a>。',
  'custom-providers.settings.sms.provider.alibaba.app-id.label': '访问密钥ID',
  'custom-providers.settings.sms.provider.alibaba.app-secret.label': '秘密访问密钥',
  'custom-providers.settings.sms.provider.alibaba.sender-id.label': '发送人ID',

  'user-data-base.breadcrumb.label': '用户数据库',
  'user-data-base.settings.tabs.users': '用户',
  'user-data-base.settings.tabs.data-storage': '数据存储',
  'user-data-base.settings.tabs.user-supplementary-info': '补充用户信息',

  /* User storage https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=1943%3A66839 */
  'user-data-base.settings.title': '用户数据存储',
  'user-data-base.settings.subtitle': '产品功能取决于所选的用户数据存储方法。',
  'user-data-base.settings.user-storage.xsolla.label': '艾克索拉存储',
  'user-data-base.settings.user-storage.xsolla.description': '默认方法。用户数据存储在艾克索拉侧。',
  'user-data-base.settings.user-storage.custom.label': '自定义存储',
  'user-data-base.settings.user-storage.custom.description': '用户数据存储在艾克索拉侧，但密码通过自定义存储进行验证。',
  'user-data-base.settings.user-storage.custom.notification.title': '通过自定义存储可以：',
  'user-data-base.settings.user-storage.custom.notification.description': '<ul><li>注册用户</li><li>通过用户名和密码认证用户</li><li>通过社交网络认证用户</li><li>重置用户密码</li><li>拦截用户</li></ul>',
  'user-data-base.settings.user-storage.custom.login_url.label': '用户验证URL',
  'user-data-base.settings.user-storage.custom.login_url.link': '用户验证请求示例',
  'user-data-base.settings.user-storage.custom.registration_url.label': '新用户URL',
  'user-data-base.settings.user-storage.custom.registration_url.link': '新用户请求示例',
  'user-data-base.settings.user-storage.custom.password_reset_url.label': '密码重置URL',
  'user-data-base.settings.user-storage.custom.password_reset_url.link': '密码重置请求示例',
  'user-data-base.settings.user-storage.custom.email_change_url.label': '电子邮箱更改URL',
  'user-data-base.settings.user-storage.custom.email_change_url.link': '邮箱更改请求示例',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.label': '免密登录URL',
  'user-data-base.settings.user-storage.custom.passwordless_registration_url.link': '免密登录请求示例',
  'user-data-base.settings.user-storage.custom.social_url.label': '社交帐户登录URL',
  'user-data-base.settings.user-storage.custom.social_url.link': '社交帐户登录请求示例',
  'user-data-base.settings.user-storage.custom.refresh_token_url.label': '刷新令牌 URL',
  'user-data-base.settings.user-storage.custom.refresh_token_url.link': '刷新令牌請求範例',
  'user-data-base.settings.user-storage.custom.add_social_access_token.label': '允许社交网络访问令牌',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.label': '启用用户账户链接',
  'user-data-base.settings.user-storage.custom.add_user_account_linking.description': '启用此选项后，我们的系统会将所有共享相同 server_custom_id 的账户视为单个用户。',
  'user-data-base.settings.user-storage.playfab.label': 'PlayFab',
  'user-data-base.settings.user-storage.playfab.description': '用户数据存储在艾克索拉侧，但密码通过PlayFab进行验证。',
  'user-data-base.settings.user-storage.playfab.notification.title': '通过PlayFab可以：',
  'user-data-base.settings.user-storage.playfab.notification.description': '<ul><li>注册用户</li><li>通过邮箱地址和密码认证用户</li><li>通过Twitch认证用户</li><li>重置用户密码</li><li>拦截用户</li></ul>',
  'user-data-base.settings.user-storage.playfab.title-id.notification': '在游戏ID字段中，输入PlayFab帐户中同一字段的值。',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.label': '游戏ID',
  'user-data-base.settings.user-storage.playfab.playfab_title_id.link': '如何获取游戏ID',
  'user-data-base.settings.user-storage.firebase.label': 'Firebase',
  'user-data-base.settings.user-storage.firebase.description': '用户数据以JSON格式存储，并在每次客户端连接时实时更新。',
  'user-data-base.settings.user-storage.firebase.notification': '在游戏ID字段中，输入PlayFab帐户中同一字段的值。',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.label': 'API密钥',
  'user-data-base.settings.user-storage.firebase.firebase_apikey.link': '如何找到API密钥',

  'user-data-base.settings.supplementary-info.main.title': '补充用户信息',
  'user-data-base.settings.supplementary-info.main.subtitle': '使用额外表单收集必需的用户数据。用户可以在注册后填写此表单。',
  'user-data-base.settings.supplementary-info.main.notification': '您可以使用标准字段或添加自定义字段来收集数据。数据将保存在用户数据库的用户资料中。可单击星号图标将字段标记为必填。',
  'user-data-base.settings.supplementary-info.fields-additional': '补充用户信息字段',
  'user-data-base.settings.supplementary-info.field.email': '电子邮箱',
  'user-data-base.settings.supplementary-info.field.username': '用户名',
  'user-data-base.settings.supplementary-info.field.password': '密码',
  'user-data-base.settings.supplementary-info.field.given-name': '名字',
  'user-data-base.settings.supplementary-info.field.family-name': '姓氏',
  'user-data-base.settings.supplementary-info.field.bday': '出生日期',
  'user-data-base.settings.supplementary-info.field.gender': '性别',
  'user-data-base.settings.supplementary-info.field.country-name': '国家/地区',
  'user-data-base.settings.supplementary-info.field.phone_number': '手机号码',
  'user-data-base.settings.supplementary-info.field.promo_email_agreement': '电子简讯',
  'user-data-base.settings.supplementary-info.field.additional_agreement': '其他协议',
  'user-data-base.settings.supplementary-info.field.standart-field': '无法更改标准字段的名称和类型。',
  'user-data-base.settings.supplementary-info.field.required': '单击星号图标将字段标记为必填。',
  'user-data-base.settings.supplementary-info.field-type.str': '短文字回答',
  'user-data-base.settings.supplementary-info.field-type.pass': '密码',
  'user-data-base.settings.supplementary-info.field-type.date': '日期选择器',
  'user-data-base.settings.supplementary-info.field-type.bool': '复选框',
  'user-data-base.settings.supplementary-info.field-type.email': '电子邮箱',
  'user-data-base.settings.supplementary-info.field-type.select': '选择',
  'user-data-base.settings.supplementary-info.field-type.phone': '手机号',
  'user-data-base.settings.supplementary-info.default-language.notification': '请用英文输入自定义字段的名称以便我们正确进行本地化。',
  'user-data-base.settings.supplementary-info.age-restrict': '需要添加年龄限制？<a>请前往年龄限制设置。</a>',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=7945%3A99727 */
  'user-data-base.settings.tabs.user-attributes': '用户属性机制',
  'user-data-base.settings.attributes.title': '用户属性机制',
  'user-data-base.settings.attributes.subtitle': '用户属性是可用于管理每个用户的数据访问权限及提供定制体验的用户元数据。<br></br>立即添加JSON机制来优化属性配置过程吧。',
  'user-data-base.settings.attributes.notification': '通过JSON机制，您可以：<ul><li>描述现有的数据格式。</li><li>具有清晰的可人读和可机读文档。</li><li>验证数据以用于自动测试及客户端提交数据的质量保证。</li></ul>',
  'user-data-base.settings.attributes.notification-link': '如需更多信息，<a>请参阅JSON机制规范。</a>',
  'user-data-base.settings.attributes.field.title': '用户属性规范',
  'user-data-base.settings.attributes.error.title': '机制无效',
  'user-data-base.settings.attributes.error.default': 'JSON机制无效或定义的属性具有的嵌套层级超过1层。',
  'user-data-base.settings.attributes.error.characters': "JSON机制包含一个或多个无效字符\"{characters}\"。",
  'user-data-base.settings.attributes.error.type': "\"{name}\"属性必须为以下类型之一：字符串、数字、整数或布尔。",
  'user-data-base.settings.attributes.error.properties-required': "属性字段为必填。",

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5898%3A102126
  'mfa.settings.title': '多因素认证政策',
  'mfa.settings.subtitle': '多因素认证要求用户在登录过程中完成额外步骤以防止未授权的访问。',
  'mfa.settings.usage.title': '使用多因素认证',
  'mfa.settings.usage.subtitle': '选择何时使用多因素认证。',
  'mfa.settings.never.title': '永不',
  'mfa.settings.never.description': '用户永远无需完成额外步骤来登录。',
  'mfa.settings.adaptive.title': '动态使用多因素认证',
  'mfa.settings.adaptive.description': '仅在登录尝试判断为有风险时强制让用户完成额外步骤。',
  'mfa.settings.always.title': '始终',
  'mfa.settings.always.description': '用户必须始终完成额外步骤来登录。',
  'mfa.settings.risk.title': '启用多因素认证',
  'mfa.settings.risk.description': '开启此选项将要求所有用户通过电子邮件使用多因素认证登录。',
  'mfa.settings.url.title': '多因素认证 URL',
  'mfa.settings.url.description': '用户将被重定向到此 URL 以完成多因素认证流程。',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3944%3A84284
  'settings.signature.title': 'JWT签名',
  'settings.signature.subtitle': '在下方选择一种用于JWT签名的加密方式。',
  'settings.signature.notification': '默认情况下将隐藏您的密钥，您必须妥善保管密钥，因为通过它能访问您的敏感信息。',
  'settings.signature.copy': '复制密钥',
  'settings.signature.hmac.label': '密钥',
  'settings.signature.hmac.new.label': '新密钥',
  'settings.signature.rsa.label': 'JSON Web公钥',
  'settings.signature.rsa.new.label': '新JSON Web公钥',
  'settings.signature.hmac.switch.title': 'HS256（使用SHA-256算法的HMAC）',
  'settings.signature.hmac.switch.caption': 'HS256使用同一个密钥来签名和验证JWT。该密钥应保存在您的一侧以用户JWT验证。',
  'settings.signature.rsa.switch.title': 'RS256（使用SHA-256算法的RSA签名）',
  'settings.signature.rsa.switch.caption': 'RS256是一个非对称算法，有一个用于给JWT签名的密钥和一个用于验证JWT的公钥。',
  'settings.signature.reset.title': '应用新密钥？',
  'settings.signature.reset.hmac.title': '重置密钥',
  'settings.signature.reset.rsa.title': '重置JSON Web密钥',
  'settings.signature.reset.hmac.description': '应用新密钥后当前密钥将无法恢复。',
  'settings.signature.reset.rsa.description': '应用新公钥后当前JSON Web公钥将无法恢复。',
  'settings.signature.reset.description': '请确保您的所有应用程序已更新为新密钥。<br></br>所有新的JWT将使用新密钥进行签名。',
  'settings.signature.reset.checkbox': '我明白',
  'settings.signature.reset.submit': '是，应用',
  'settings.signature.token-lifetime.title': '令牌有效期',
  'settings.signature.token-lifetime.description': '该令牌将在生命周期结束后过期。<br></br>默认生命周期为1天（86400秒）。',
  'settings.signature.token-lifetime.description-oauth': 'OAuth 2.0令牌将在有效期结束后过期。<br></br>默认有效期为1小时（3600秒）。',
  'settings.signature.token-lifetime.seconds': '秒',
  'settings.signature.notification.title': '已生成新密钥',
  'settings.signature.notification.caption': '复制新密钥并应用至所有依赖的应用程序。全部更新后，请单击“保存更改”。',
  'settings.signature.long-token-checkbox': '您的令牌有效期超过 5 天，请单击复选框以确认。',

  /* https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5647%3A93743 */
  'sms-customization.settings.title': '短信自定义',
  'sms-customization.settings.subtitle': '自定义发送给用户的验证码短信。',
  'sms-customization.settings.main.notification': '如要在短信中使用自定义文本，请自行为需要的语言添加相应的文本。否则用户将收到标准艾克索拉验证消息。<p>了解如何通过Liquid Syntax自定义消息。</p>',
  'sms-customization.settings.input.title': '注册和登录消息',
  'sms-customization.settings.phone_auth_code.title': '注册和登录消息',
  'sms-customization.settings.phone_auth_code.description': '每次用户登录或注册时发送此消息。',
  'sms-customization.settings.phone_auth_code.placeholder': '示例：{{code}}是{{Game}}的验证码。您也可以通过{{link}}登录。',
  'sms-customization.settings.phone_auth_code.post-description': '{{code}}、{{Game}}和{{link}}标记将自动替换为真实值。请勿尝试在此字段中输入真实验证码、链接或名称。',
  'sms-customization.settings.mfa_code.title': '多因素认证消息',
  'sms-customization.settings.mfa_code.description': '每次用户首次使用一个新设备登录时发送此消息。<a>设置MFA方式。</a>',
  'sms-customization.settings.mfa_code.placeholder': '示例：{{code}}是{{Game}}的验证码。',
  'sms-customization.settings.mfa_code.post-description': '{{code}}和{{Game}}标记将自动替换为真实值。请勿尝试在此字段中输入真实验证码或名称。',
  'sms-customization.settings.limit-symbol.error': '短信必须少于{number}个字符。',
  'sms-customization.settings.not-code.error': '模板必须包含验证码的标记。',

  /* Custom scopes https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=3724%3A81985 */
  'social-connection.settings.user-data.profile': '资料',
  'social-connection.settings.user-data.public-profile': '公开资料',
  'social-connection.settings.user-data.other-profile': '用户全部资料',
  'social-connection.settings.user-data.id': '用户ID',
  'social-connection.settings.user-data.email': '用户邮箱地址',
  'social-connection.settings.user-data.phone': '手机号码',
  'social-connection.settings.user-data.image': '资料图片',
  'social-connection.settings.user-data.name': '名称',
  'social-connection.settings.user-data.nickname': '昵称',
  'social-connection.settings.user-data.age-range': '年龄范围',
  'social-connection.settings.user-data.birthday': '出生日期',
  'social-connection.settings.user-data.birthyear': '出生年份',
  'social-connection.settings.user-data.location': '位置',
  'social-connection.settings.user-data.gender': '性别',
  'social-connection.settings.user-data.hometown': '籍贯',
  'social-connection.settings.user-data.address': '地址',
  'social-connection.settings.user-data.likes': '赞',
  'social-connection.settings.user-data.link': '资料URL',
  'social-connection.settings.user-data.postal-code': '邮编',
  'social-connection.settings.user-data.connections': '社交网络连接',
  'social-connection.settings.user-data.profile-instagram': 'Instagram资料',
  'social-connection.settings.user-data.openid': 'OpenID用户详细信息',
  'social-connection.settings.user-data.guilds': '用户帮会资料',
  'social-connection.settings.user-data.long-token': '具有较长过期时间的令牌',
  'social-connection.settings.user-data.profile-d3': 'Diablo III资料',
  'social-connection.settings.user-data.profile-sc2': 'StarCraft II资料',
  'social-connection.settings.user-data.profile-wow': '魔兽世界角色',
  'social-connection.settings.user-data.offline': '离线访问',

  'social-connection.settings.permission.all': '请求所有scope',
  'social-connection.settings.permission.user': '读取/更新用户资料',
  'social-connection.settings.permission.user-subscriptions:read': '读取用户订阅',
  'social-connection.settings.permission.user-block:read': '查看拦截列表',
  'social-connection.settings.permission.user-block:write': '管理拦截列表',
  'social-connection.settings.permission.messenger-contact': '用通讯工具联系',
  'social-connection.settings.permission.photos': '照片',
  'social-connection.settings.permission.posts': '帖子',
  'social-connection.settings.permission.videos': '视频',
  'social-connection.settings.permission.groups': '群组',
  'social-connection.settings.permission.groups:read': '读取群信息',
  'social-connection.settings.permission.groups:write': '管理群内容',
  'social-connection.settings.permission.groups:stats': '访问群数据',
  'social-connection.settings.permission.friends': '好友',
  'social-connection.settings.permission.plusfriends': '好友',
  'social-connection.settings.permission.stories': '访问故事',
  'social-connection.settings.permission.status': '访问用户状态',
  'social-connection.settings.permission.notes': '访问用户笔记',
  'social-connection.settings.permission.wall': '访问资料Feed技术',
  'social-connection.settings.permission.offline': '离线访问API',
  'social-connection.settings.permission.notify': '向用户发送通知',
  'social-connection.settings.permission.market': '访问商品',
  'social-connection.settings.permission.users': '读取/更新全部用户的完整资料',
  'social-connection.settings.permission.users-follow:read': '查看用户的关注列表',
  'social-connection.settings.permission.users-follow:write': '关注/取消关注其他用户',
  'social-connection.settings.permission.users:invite': '邀请访客用户加入组织',
  'social-connection.settings.permission.users:export': '导出用户数据',
  'social-connection.settings.permission.users:manage': '管理用户身份',
  'social-connection.settings.permission.files': '获取用户文件的访问权限',
  'social-connection.settings.permission.send-messages': '向用户发送消息',
  'social-connection.settings.permission.country': '国家',
  'social-connection.settings.permission.presence:read': '读取用户的状态信息',
  'social-connection.settings.permission.presence:write': '读写用户的状态信息',
  'social-connection.settings.permission.activities:read': '读取用户活动',
  'social-connection.settings.permission.activities:write': '更新用户活动',
  'social-connection.settings.permission.application:invite': '邀请用户加入应用程序',
  'social-connection.settings.permission.applications-builds:read': '读取版本信息',
  'social-connection.settings.permission.applications-builds:upload': '上传版本信息',
  'social-connection.settings.permission.applications-commands': '使用命令',
  'social-connection.settings.permission.applications-commands:update': '更新命令',
  'social-connection.settings.permission.applications-entitlements': '读取权利',
  'social-connection.settings.permission.applications-store:update': '读取/更新商店数据',
  'social-connection.settings.permission.bot': '机器人',
  'social-connection.settings.permission.gdm:join': '帮会加入',
  'social-connection.settings.permission.guilds:join': '将用户加入帮会',
  'social-connection.settings.permission.messages:read': '读取用户消息',
  'social-connection.settings.permission.messages:write': '读取/发送用户消息',
  'social-connection.settings.permission.relationships:read': '获取用户好友',
  'social-connection.settings.permission.rpc': 'RPC服务器访问',
  'social-connection.settings.permission.rpc-activities:write': '更新用户活动(RPC)',
  'social-connection.settings.permission.rpc-notifications:read': '接收通知(RPC)',
  'social-connection.settings.permission.rpc-voice:read': '读取语音设置',
  'social-connection.settings.permission.rpc-voice:write': '更新语音设置',
  'social-connection.settings.permission.webhook-incoming': '生成Webhook',
  'social-connection.settings.permission.identify:premium': '识别高级订阅(Nitro)',
  'social-connection.settings.permission.ads:read': '读取广告',
  'social-connection.settings.permission.ads:write': '管理广告',
  'social-connection.settings.permission.ads-report:read': '读取广告报告',
  'social-connection.settings.permission.ads-leads:read': '读取广告销售线索报告',
  'social-connection.settings.permission.ads-publishers:read': '读取内容商的广告',
  'social-connection.settings.permission.attribution:read': '读取Attribution API',
  'social-connection.settings.permission.business:write': '管理Business Manager API',
  'social-connection.settings.permission.catalog:write': '管理产品目录',
  'social-connection.settings.permission.gaming-user_locale': '获取用户区域设置',
  'social-connection.settings.permission.instagram:publish': '发布Instagram照片',
  'social-connection.settings.permission.instagram-comments:write': '管理Instagram评论',
  'social-connection.settings.permission.instagram-insights:write': '读取Instagram洞察数据',
  'social-connection.settings.permission.leads:read': '读取销售线索广告',
  'social-connection.settings.permission.pages-events': '管理Facebook主页',
  'social-connection.settings.permission.ads-pages:write': '管理Facebook主页广告',
  'social-connection.settings.permission.cta:write': '管理CTA操作',
  'social-connection.settings.permission.pages-articles:write': '管理Instant Articles',
  'social-connection.settings.permission.pages-engagement:write': '管理主页评论',
  'social-connection.settings.permission.pages-metadata:write': '接收主页Webhook',
  'social-connection.settings.permission.pages-posts:write': '管理帖文',
  'social-connection.settings.permission.pages-messaging': '管理主页消息',
  'social-connection.settings.permission.pages-engagement:read': '读取主页内容',
  'social-connection.settings.permission.pages-content:read': '读取主页评论',
  'social-connection.settings.permission.pages-list': '读取用户主页',
  'social-connection.settings.permission.pages-gender': '读取用户主页上的性别',
  'social-connection.settings.permission.pages-locale': '读取用户主页上的区域设置',
  'social-connection.settings.permission.pages-timezone': '读取用户主页上的时区',
  'social-connection.settings.permission.social-user:write': '通过用户管理帖文',
  'social-connection.settings.permission.social-org:read': '查看组织帖文',
  'social-connection.settings.permission.social-org:write': '通过组织管理帖文',
  'social-connection.settings.permission.video:write': '发布视频',
  'social-connection.settings.permission.insights:read': '读取主页的洞察数据',
  'social-connection.settings.permission.research-apis': '访问Research API',
  'social-connection.settings.permission.repo': '存储库的完整访问权限',
  'social-connection.settings.permission.repo:status': '读/写提交状态',
  'social-connection.settings.permission.repo_deployment': '访问部署状态',
  'social-connection.settings.permission.public_repo': '访问公开存储库',
  'social-connection.settings.permission.repo:invite': '接受/拒绝邀请',
  'social-connection.settings.permission.security_events': '读/写安全性事件',
  'social-connection.settings.permission.admin:repo_hook': '以管理员权限访问存储库钩子',
  'social-connection.settings.permission.write:repo_hook': '写入存储库钩子',
  'social-connection.settings.permission.read:repo_hook': '读取存储库钩子',
  'social-connection.settings.permission.admin:org': '以管理员权限访问组织',
  'social-connection.settings.permission.write:org': '写入组织',
  'social-connection.settings.permission.read:org': '读取组织',
  'social-connection.settings.permission.admin:public_key': '以管理员权限访问公钥',
  'social-connection.settings.permission.write:public_key': '写入公钥',
  'social-connection.settings.permission.read:public_key': '读取公钥',
  'social-connection.settings.permission.admin:org_hook': '以管理员权限访问组织钩子',
  'social-connection.settings.permission.gist': '写入Gist',
  'social-connection.settings.permission.notifications': '访问用户的通知',
  'social-connection.settings.permission.delete_repo': '删除存储库',
  'social-connection.settings.permission.write:discussion': '写入工作组讨论',
  'social-connection.settings.permission.read:discussion': '读取工作组讨论',
  'social-connection.settings.permission.write:packages': '发布包的权限',
  'social-connection.settings.permission.read:packages': '下载包的权限',
  'social-connection.settings.permission.delete:packages': '删除包的权限',
  'social-connection.settings.permission.admin:gpg_key': '以管理员权限访问GPG密钥',
  'social-connection.settings.permission.write:gpg_key': '写入GPG密钥',
  'social-connection.settings.permission.read:gpg_key': '读取GPG密钥',
  'social-connection.settings.permission.codespace': '创建和管理工作区',
  'social-connection.settings.permission.workflow': '上传GitHub Actions工作流文件',
  'social-connection.settings.permission.cloud-platform': '云端平台',
  'social-connection.settings.permission.adsense': 'AdSense',
  'social-connection.settings.permission.analytics': '分析',
  'social-connection.settings.permission.analytics-extensions': '用于Twitch扩展的分析',
  'social-connection.settings.permission.analytics-games': '用于游戏的分析',
  'social-connection.settings.permission.appengine:admin': 'App Engine',
  'social-connection.settings.permission.mail:read': '读取用户邮件',
  'social-connection.settings.permission.mail:write': '读写用户邮件',
  'social-connection.settings.permission.mail:send': '以用户名义发送邮件',
  'social-connection.settings.permission.bigquery': 'BigQuery',
  'social-connection.settings.permission.blogger': 'Blogger',
  'social-connection.settings.permission.books': '图书',
  'social-connection.settings.permission.calendar:read': '读取日历',
  'social-connection.settings.permission.calendar:write': '管理日历',
  'social-connection.settings.permission.ddmconversions': 'DoubleClick Digital Marketing',
  'social-connection.settings.permission.bigtable': 'Cloud Bigtable',
  'social-connection.settings.permission.content': 'Shopping',
  'social-connection.settings.permission.display-video': 'Display & Video 360',
  'social-connection.settings.permission.doubleclickbidmanager': 'DoubleClick Bid Manager',
  'social-connection.settings.permission.files:read': '读取用户文件',
  'social-connection.settings.permission.files:write': '用户文件的完整访问权限',
  'social-connection.settings.permission.firebase': 'Firebase',
  'social-connection.settings.permission.fitness': '健身',
  'social-connection.settings.permission.ediscovery': 'G Suite Vault',
  'social-connection.settings.permission.classroom': 'Classroom',
  'social-connection.settings.permission.documents': '文档',
  'social-connection.settings.permission.androidpublisher': 'Google Play',
  'social-connection.settings.permission.games': 'Google Play Games活动',
  'social-connection.settings.permission.webmasters': 'Search Console',
  'social-connection.settings.permission.presentations': '幻灯片',
  'social-connection.settings.permission.spreadsheets': '表格',
  'social-connection.settings.permission.manufacturercenter': 'Manufacturer Center',
  'social-connection.settings.permission.contacts:read': '读取用户联系人',
  'social-connection.settings.permission.contacts:write': '管理用户联系人',
  'social-connection.settings.permission.photoslibrary': '相册',
  'social-connection.settings.permission.tagmanager': 'Tag Manager',
  'social-connection.settings.permission.tasks': '任务',
  'social-connection.settings.permission.youtube': 'YouTube',
  'social-connection.settings.permission.story:read': '读取KakaoStory帖文',
  'social-connection.settings.permission.story:publish': '在KakaoStory中发布内容',
  'social-connection.settings.permission.talk:message': 'KakaoTalk',
  'social-connection.settings.permission.connections-1st:view': '查看一度人脉联系人',
  'social-connection.settings.permission.audience:write': '管理匹配audience',
  'social-connection.settings.permission.guestbook': '写入留言列表',
  'social-connection.settings.permission.apps:read': '读取所有应用目录',
  'social-connection.settings.permission.apps:write': '读写所有应用目录',
  'social-connection.settings.permission.logs:read': '读取审核日志数据',
  'social-connection.settings.permission.bookings:read': '读取Bookings预订',
  'social-connection.settings.permission.bookings:write': '管理Bookings预订',
  'social-connection.settings.permission.call': '主动发起一对一通话',
  'social-connection.settings.permission.call-group': '主动发起群通话',
  'social-connection.settings.permission.device:read': '读取用户设备',
  'social-connection.settings.permission.notes:read': '读取用户OneNote笔记本',
  'social-connection.settings.permission.notes:write': '读写用户OneNote笔记本',
  'social-connection.settings.permission.tasks:read': '读取用户的任务和任务列表',
  'social-connection.settings.permission.tasks:write': '创建和更新用户任务',
  'social-connection.settings.permission.credits': '消耗金积分',
  'social-connection.settings.permission.flair': '管理用户的标签',
  'social-connection.settings.permission.votes:read': '读取投票历史',
  'social-connection.settings.permission.live-threads:read': '管理实时讨论帖',
  'social-connection.settings.permission.modconfig': '审核社区配置',
  'social-connection.settings.permission.modcontributors': '批准和封禁用户',
  'social-connection.settings.permission.modflair': '审核标签',
  'social-connection.settings.permission.modlog': '审核日志',
  'social-connection.settings.permission.modmail': '新建Modmail',
  'social-connection.settings.permission.modothers': '邀请或删除其他版主',
  'social-connection.settings.permission.modposts': '审核帖子',
  'social-connection.settings.permission.modself': '管理版主状态',
  'social-connection.settings.permission.modwiki': '审核Wiki',
  'social-connection.settings.permission.mysubreddits': '我的社区',
  'social-connection.settings.permission.report': '报告内容',
  'social-connection.settings.permission.save': '保存内容',
  'social-connection.settings.permission.structuredstyles': '编辑结构样式',
  'social-connection.settings.permission.submit': '提交内容',
  'social-connection.settings.permission.subscribe': '编辑我的订阅',
  'social-connection.settings.permission.vote': '投票',
  'social-connection.settings.permission.wiki:edit': 'Wiki编辑',
  'social-connection.settings.permission.wiki:read': '读取Wiki页面',
  'social-connection.settings.permission.bits:read': '查看呼币信息',
  'social-connection.settings.permission.channel:edit:commercial': '在频道中播广告',
  'social-connection.settings.permission.channel:manage:broadcast': '管理频道的广播配置',
  'social-connection.settings.permission.channel:manage:extensions': '管理频道的扩展配置',
  'social-connection.settings.permission.channel:manage:polls': '管理频道的投票',
  'social-connection.settings.permission.channel:manage:predictions': '管理频道的忠诚点数预测',
  'social-connection.settings.permission.channel:manage:redemptions': '管理忠诚点数自定义奖励',
  'social-connection.settings.permission.channel:manage:schedule': '管理频道的直播排期',
  'social-connection.settings.permission.channel:manage:videos': '管理频道的视频',
  'social-connection.settings.permission.channel:read:editors': '查看编辑者角色的用户',
  'social-connection.settings.permission.channel:read:goals': '查看频道的创作者目标',
  'social-connection.settings.permission.channel:read:hype_train': '查看频道的Hype Train信息',
  'social-connection.settings.permission.channel:read:polls': '查看频道的投票',
  'social-connection.settings.permission.channel:read:predictions': '查看频道的忠诚点数预测',
  'social-connection.settings.permission.channel:read:redemptions': '查看忠诚点数自定义奖励',
  'social-connection.settings.permission.channel:read:stream_key': '查看授权用户的直播密钥',
  'social-connection.settings.permission.channel:read:subscriptions': '查看全部订阅者的列表',
  'social-connection.settings.permission.clips:edit': '管理频道的剪辑',
  'social-connection.settings.permission.moderation:read': '查看频道的审核数据',
  'social-connection.settings.permission.moderator:manage:banned_users': '封禁和解封用户',
  'social-connection.settings.permission.moderator:read:blocked_terms': '查看主播的禁用词列表',
  'social-connection.settings.permission.moderator:manage:blocked_terms': '管理主播的禁用词列表',
  'social-connection.settings.permission.moderator:manage:automod': '管理AutoMod中的消息',
  'social-connection.settings.permission.moderator:read:automod_settings': '查看主播的AutoMod设置',
  'social-connection.settings.permission.moderator:manage:automod_settings': '管理主播的AutoMod设置',
  'social-connection.settings.permission.moderator:read:chat_settings': '查看主播的聊天室设置',
  'social-connection.settings.permission.moderator:manage:chat_settings': '管理主播的聊天室设置',
  'social-connection.settings.permission.promo-codes:vimeo': 'Vimeo推广',
  'social-connection.settings.permission.upload:vimeo': '上传视频',
  'social-connection.settings.permission.interact:vimeo': '与Vimeo资源交互',
  'social-connection.settings.permission.delete:vimeo': '删除现有Vimeo资源',
  'social-connection.settings.permission.edit:vimeo': '编辑现有Vimeo资源',
  'social-connection.settings.permission.create:vimeo': '新建Vimeo资源',
  'social-connection.settings.permission.purchased:vimeo': '访问购买历史记录',
  'social-connection.settings.permission.audio': '访问音频录音',
  'social-connection.settings.permission.fantasy-sport:read': '读取Fantasy Sports',
  'social-connection.settings.permission.fantasy-sport:write': '读/写Fantasy Sports',
  'social-connection.settings.permission.finance:read': '读取财经',
  'social-connection.settings.permission.finance:write': '读写财经',

  'social-connection.settings.user-data.amazon.profile.help': '资料scope包含用户的名称、用户ID和邮箱地址。',
  'social-connection.settings.user-data.amazon.id.help': '用户ID scope仅包含资料的user_id字段。这可以唯一识别出用户而不提供其名称、邮箱地址或邮编。',
  'social-connection.settings.user-data.amazon.postal-code.help': '邮编scope包含用户主要收货地址的邮政编码信息。',
  'social-connection.settings.user-data.apple.name.help': '用户的全名。',
  'social-connection.settings.user-data.apple.email.help': '用户的邮箱。',
  'social-connection.settings.user-data.baidu.profile.help': '基本用户权限，您可以获取基本用户信息。',
  'social-connection.settings.user-data.battlenet.openid.help': '访问使用OpenID Connect (OIDC)登录的当前用户的详细信息。',
  'social-connection.settings.user-data.battlenet.profile-d3.help': '访问用户的Diablo III资料。',
  'social-connection.settings.user-data.battlenet.profile-sc2.help': '访问用户的StarCraft II资料。',
  'social-connection.settings.user-data.battlenet.profile-wow.help': '访问用户的魔兽世界角色。',
  'social-connection.settings.user-data.discord.profile.help': '允许没有邮箱地址的/users/@me。',
  'social-connection.settings.user-data.discord.email.help': '允许/users/@me返回邮箱地址。',
  'social-connection.settings.user-data.discord.connections.help': '允许/users/@me/connections返回关联的第三方帐户。',
  'social-connection.settings.user-data.discord.guilds.help': '允许/users/@me/guilds返回用户全部帮会的基本信息。',
  'social-connection.settings.user-data.epicgames.profile.help': '允许读取用户显示名称、语言偏好和关联帐户显示名称。',
  'social-connection.settings.user-data.facebook.profile.help': '允许应用读取用户节点上的默认公开资料字段。该权限自动授予所有应用。',
  'social-connection.settings.user-data.facebook.email.help': '邮箱权限允许您的应用读取用户的主要邮箱地址。',
  'social-connection.settings.user-data.facebook.age-range.help': 'user_age_range权限允许您的应用访问用户在其Facebook资料中列出的年龄范围。',
  'social-connection.settings.user-data.facebook.birthday.help': 'user_birthday权限允许您的应用读取用户在其Facebook资料中列出的出生日期。',
  'social-connection.settings.user-data.facebook.gender.help': 'user_gender权限允许您的应用读取用户在其Facebook资料中列出的性别。',
  'social-connection.settings.user-data.facebook.hometown.help': 'user_hometown权限允许您的应用从用户的Facebook资料中读取用户的籍贯位置。',
  'social-connection.settings.user-data.facebook.likes.help': 'user_likes权限允许您的应用读取用户赞过的所有Facebook主页列表。',
  'social-connection.settings.user-data.facebook.link.help': 'user_link权限允许您的应用访问用户的Facebook资料URL。',
  'social-connection.settings.user-data.facebook.location.help': 'user_location权限允许您的应用读取用户Facebook资料中位置字段列出的城市名称。',
  'social-connection.settings.user-data.facebook.profile-instagram.help': 'instagram_basic权限允许您的应用读取Instagram帐户资料的信息和媒体文件。',
  'social-connection.settings.user-data.github.public-profile.help': '授予公开信息的只读权限（包括用户资料信息、存储库信息和Gist）。',
  'social-connection.settings.user-data.github.profile.help': '授予读取用户资料数据的权限。',
  'social-connection.settings.user-data.github.email.help': '授予用户邮箱地址的读取权限。',
  'social-connection.settings.user-data.google.profile.help': '查看您的个人信息，包括您可公开访问的任何个人信息。',
  'social-connection.settings.user-data.google.email.help': '查看您的邮箱地址。',
  'social-connection.settings.user-data.google.openid.help': '将您与您的Google个人信息关联。',
  'social-connection.settings.user-data.kakao.profile.help': 'Kakao帐户的资料信息。',
  'social-connection.settings.user-data.kakao.nickname.help': 'Kakao帐户的昵称。',
  'social-connection.settings.user-data.kakao.image.help': '资料图片URL。',
  'social-connection.settings.user-data.kakao.email.help': 'Kakao帐户的代表邮箱。用户Kakao帐户中不一定会收集邮箱信息。该情况下，请在收集信息选项后使用Provision，或在您的服务内部进行收集。用户的Kakao帐户邮箱不一定完成了验证。如果您的服务只能使用经验证的邮箱，请让未验证邮箱的用户前往验证流程。',
  'social-connection.settings.user-data.kakao.name.help': 'Kakao帐户的名称。',
  'social-connection.settings.user-data.kakao.gender.help': 'Kakao帐户中的性别。',
  'social-connection.settings.user-data.kakao.age-range.help': 'Kakao帐户的年龄范围（基于韩国的年龄定义）。',
  'social-connection.settings.user-data.kakao.birthday.help': 'Kakao帐户中的出生日期。',
  'social-connection.settings.user-data.kakao.birthyear.help': 'Kakao帐户中的出生年份。',
  'social-connection.settings.user-data.kakao.phone.help': 'Kakao帐户中的手机号码。',
  'social-connection.settings.user-data.kakao.id.help': '加密用户身份的值。ID只能用于检查同一用户是否已在会员数据库中注册过。',
  'social-connection.settings.user-data.kakao.address.help': 'Kakao帐户的收货信息。',
  'social-connection.settings.user-data.kakao.link.help': 'Kakao Story资料URL。',
  'social-connection.settings.user-data.linkedin.public-profile.help': '读取已认证会员的基本资料，包括名称、照片、头条和公开资料URL。',
  'social-connection.settings.user-data.linkedin.profile.help': '检索已认证会员的名称、头条和照片。',
  'social-connection.settings.user-data.linkedin.email.help': '检索已认证会员的主要邮箱地址。',
  'social-connection.settings.user-data.mailru.public-profile.help': '读取认证用户的基本资料，包括名称、照片、出生日期和其他字段。',
  'social-connection.settings.user-data.microsoft.public-profile.help': '允许用户登录应用并允许应用读取已登录用户的资料。此外，还允许应用读取已登录用户的基本公司信息。',
  'social-connection.settings.user-data.microsoft.other-profile.help': '允许应用代表已登录用户读取您组织内其他用户的一组基本资料属性，包括显示名称、姓名、邮箱地址、开放扩展和照片。此外，还允许应用读取已登录用户的完整资料。',
  'social-connection.settings.user-data.microsoft.profile.help': '允许应用代表已登录用户读取一组完整的资料属性、报告及组织内其他用户的经理。',
  'social-connection.settings.user-data.ok.profile.help': '调用大部分方法都需要的基本权限。',
  'social-connection.settings.user-data.ok.email.help': '访问用户的邮箱地址。',
  'social-connection.settings.user-data.ok.long-token.help': '从OAuth授权获取拥有较长过期时间的令牌。',
  'social-connection.settings.user-data.paypal.openid.help': '基本认证。',
  'social-connection.settings.user-data.paypal.profile.help': '访问用户的全名。',
  'social-connection.settings.user-data.paypal.email.help': '访问用户的邮箱地址。',
  'social-connection.settings.user-data.paypal.address.help': '访问用户的完整地址。',
  'social-connection.settings.user-data.paypal.id.help': '访问PayPal帐户ID（付款人ID）和帐户验证状态。',
  'social-connection.settings.user-data.qq.profile.help': '获取已登录用户的昵称、头像和性别。',
  'social-connection.settings.user-data.reddit.profile.help': '访问用户的Reddit用户名和注册日期。',
  'social-connection.settings.user-data.twitch.email.help': '查看用户的邮箱地址。',
  'social-connection.settings.user-data.vimeo.public-profile.help': '访问公开会员数据。',
  'social-connection.settings.user-data.vimeo.profile.help': '访问私密会员数据。除公开以外的任何scope都需要。',
  'social-connection.settings.user-data.vk.email.help': '访问用户的邮箱。',
  'social-connection.settings.user-data.wechat.profile.help': '基本登录权限scope。Web应用程序当前只填写snsapi_login。',
  'social-connection.settings.user-data.weibo.email.help': '用户的联系邮箱。',
  'social-connection.settings.user-data.yahoo.profile.help': '资料信息。',
  'social-connection.settings.user-data.yahoo.email.help': '邮箱地址。',

  'social-connection.settings.permission.baidu.files.help': '获取个人云存储中的用户数据。',
  'social-connection.settings.permission.baidu.send-messages.help': '向用户的百度主页发送消息提醒。',
  'social-connection.settings.permission.discord.activities:read.help': '允许您的应用从用户的“当前在玩/最近玩过”列表中拿取数据——需要Discord批准。',
  'social-connection.settings.permission.discord.activities:write.help': '允许您的应用更新用户活动——需要Discord批准（GAMESDK ACTIVITY MANAGER不要求）。',
  'social-connection.settings.permission.discord.applications-builds:read.help': '允许您的应用读取用户应用程序的版本数据。',
  'social-connection.settings.permission.discord.applications-builds:upload.help': '允许您的应用上传/更新用户应用程序的版本——需要Discord批准。',
  'social-connection.settings.permission.discord.applications-commands.help': '允许您的应用在帮会中使用命令。',
  'social-connection.settings.permission.discord.applications-commands:update.help': '允许您的应用通过此持有者令牌更新其命令——仅限授予客户端凭证的情况下。',
  'social-connection.settings.permission.discord.applications-entitlements.help': '允许您的应用读取用户应用程序的权利。',
  'social-connection.settings.permission.discord.applications-store:update.help': '允许您的应用为用户应用程序读取和更新商店数据（SKU、商店列表商品、成就等）。',
  'social-connection.settings.permission.discord.bot.help': '对于oauth2机器人，这将默认把机器人放在用户所选的帮会中。',
  'social-connection.settings.permission.discord.gdm:join.help': '允许您的应用将用户加入群聊。',
  'social-connection.settings.permission.discord.guilds:join.help': '允许将/guilds/{guild.id}/members/{user.id}用于把用户加入帮会。',
  'social-connection.settings.permission.discord.messages:read.help': '对于本地rpc服务器API访问，这将允许您的从所有客户端频道读取消息（否则仅限于您的应用创建的平道/帮会）。',
  'social-connection.settings.permission.discord.relationships:read.help': '允许您的应用了解用户的好友及背后的关系——需要Discord批准。',
  'social-connection.settings.permission.discord.rpc.help': '对于本地rpc服务器访问，这将允许您控制用户的本地Discord客户端——需要Discord批准。',
  'social-connection.settings.permission.discord.rpc-activities:write.help': '对于本地rpc服务器访问，这将允许您更新用户的活动——需要Discord批准。',
  'social-connection.settings.permission.discord.rpc-notifications:read.help': '对于本地rpc服务器访问，这将允许您接收向用户推送的通知——需要Discord批准。',
  'social-connection.settings.permission.discord.rpc-voice:read.help': '对于本地rpc服务器访问，这将允许您读取用户的语音设置并侦听语音事件——需要Discord批准。',
  'social-connection.settings.permission.discord.rpc-voice:write.help': '对于本地rpc服务器访问，这将允许您更新用户的语音设置——需要Discord批准。',
  'social-connection.settings.permission.discord.webhook-incoming.help': '这将生成一个Webhook，在对授权码发放的oauth令牌响应中返回。',
  'social-connection.settings.permission.discord.identify:premium.help': '返回用户是否拥有有效的Nitro订阅（含premium_type字段）⸺应用需获得Discord批准。',
  'social-connection.settings.permission.epicgames.friends.help': '允许读取当前用户帐户的好友列表。',
  'social-connection.settings.permission.epicgames.presence:write.help': '允许应用程序设置当前用户的在线状态机接收其好友的在线状态更新。',
  'social-connection.settings.permission.facebook.messenger-contact.help': 'user_messenger_contact权限允许商家在同意的情况下通过Messenger联系个人或使用商家主页发起一个聊天。',
  'social-connection.settings.permission.facebook.photos.help': 'user_photos权限允许您的应用读取个人上传到Facebook的照片。',
  'social-connection.settings.permission.facebook.posts.help': 'user_posts权限允许您的应用访问用户在其时间线上发布的帖文。',
  'social-connection.settings.permission.facebook.videos.help': 'user_videos权限允许您的应用读取个人上传的视频列表。',
  'social-connection.settings.permission.facebook.friends.help': 'user_friends权限允许您的应用获取用户也在使用该应用的好友列表。',
  'social-connection.settings.permission.facebook.ads:read.help': 'ads_read权限允许您的应用访问Ads Insights API以拉取您拥有的广告帐户的报告，以及被其他广告帐户所有者授权访问的广告帐户的报告。',
  'social-connection.settings.permission.facebook.ads:write.help': 'ads_management权限允许您的应用读取并管理其拥有的广告帐户，以及被其他广告帐户所有者授权访问的广告帐户。',
  'social-connection.settings.permission.facebook.attribution:read.help': 'attribution_read权限授权您的应用Attribution API的访问权限以拉取您所拥有业务线的归因报告数据或其他业务线所有者授权您访问的业务线归因报告。',
  'social-connection.settings.permission.facebook.business:write.help': 'business_management允许您的应用通过Business Manager API进行读写。',
  'social-connection.settings.permission.facebook.catalog:write.help': 'catalog_management权限允许您的应用在用户为管理员的情况下创建、读取、更新和删除商家拥有的产品目录。',
  'social-connection.settings.permission.facebook.gaming-user_locale.help': 'gaming_user_locale权限允许您的应用获取用户在Facebook上玩游戏（如Instant Games或Cloud Gaming）时的首选语言。',
  'social-connection.settings.permission.facebook.groups:read.help': '如果帖文作者授予了您的应用访问权限，groups_access_member_info权限允许应用读取可公开访问的群成员信息（如名称和ID）。',
  'social-connection.settings.permission.facebook.instagram:publish.help': 'instagram_content_publish权限允许您的应用代表商家用户创建有机Feed照片和视频帖。',
  'social-connection.settings.permission.facebook.instagram-comments:write.help': 'instagram_manage_comments权限允许您的应用代表主页关联的Instagram帐户创建、删除和隐藏评论。',
  'social-connection.settings.permission.facebook.instagram-insights:write.help': 'instagram_manage_insights权限允许您的应用访问Facebook主页关联的Instagram帐户的洞察数据。',
  'social-connection.settings.permission.facebook.leads:read.help': 'leads_retrieval权限允许您的应用检索和读取在Ads Manager或Marketing API中所创建广告关联的销售线索广告表单捕捉到的所有信息。',
  'social-connection.settings.permission.facebook.pages-events.help': 'page_events权限允许您的应用代表该应用用户所管理的Facebook主页来记录事件，并将这些事件发送给Facebook以进行广告定向、优化和报告。',
  'social-connection.settings.permission.facebook.ads-pages:write.help': 'pages_manage_ads权限允许您的应用管理主页关联的广告。',
  'social-connection.settings.permission.facebook.cta:write.help': 'pages_manage_cta权限允许您的应用执行端点上用于管理Facebook主页中行动召唤按钮的POST和DELETE函数。',
  'social-connection.settings.permission.facebook.pages-articles:write.help': 'pages_manage_instant_articles权限允许您的应用代表用户作为管理员的Facebook主页管理Instant Articles。',
  'social-connection.settings.permission.facebook.pages-engagement:write.help': 'pages_manage_engagement权限允许您的应用创建、编辑和删除主页上发布的评论。',
  'social-connection.settings.permission.facebook.pages-metadata:write.help': 'pages_manage_metadata权限允许您的应用订阅和接收主页上活动的Webhook，以及更新主页上的设置。',
  'social-connection.settings.permission.facebook.pages-posts:write.help': 'pages_manage_posts权限允许您的应用创建、编辑和删除您主页上的帖文。',
  'social-connection.settings.permission.facebook.pages-messaging.help': 'pages_messaging权限允许您的应用管理和访问Messenger中的主页对话。',
  'social-connection.settings.permission.facebook.pages-engagement:read.help': 'pages_read_engagement权限允许您的应用读取主页上发布的内容（帖子、照片、视频、活动）和资料图片，以及读取元数据和主页上的其他洞察数据。',
  'social-connection.settings.permission.facebook.pages-content:read.help': 'pages_read_user_content权限允许您的应用读取主页上的用户生成内容，如帖子、评论、用户或其他主页的评分，以及删除主页帖文中的用户评论。',
  'social-connection.settings.permission.facebook.pages-list.help': 'pages_show_list权限允许您的应用访问个人管理的主页的列表。',
  'social-connection.settings.permission.facebook.pages-gender.help': 'pages_user_gender权限允许您的应用通过应用所关联的主页访问用户的性别信息。',
  'social-connection.settings.permission.facebook.pages-locale.help': 'Pages_user_gender权限允许您的应用通过应用所关联的主页访问用户的性别信息。',
  'social-connection.settings.permission.facebook.pages-timezone.help': 'pages_user_timezone权限授权您的应用通过应用所关联的主页访问用户的时区信息。',
  'social-connection.settings.permission.facebook.groups:write.help': '应用获得授权后，publish_to_groups权限允许您的应用代表用户将内容发布到群组中。',
  'social-connection.settings.permission.facebook.video:write.help': 'publish_video权限允许您的应用将实时视频发布到应用的用户时间线、群组、活动或主页。',
  'social-connection.settings.permission.facebook.insights:read.help': 'read_insights权限允许您的应用读取个人拥有的主页、应用和Web域名的洞察数据。',
  'social-connection.settings.permission.facebook.research-apis.help': 'research_apis权限允许您的应用访问Facebook Open Research and Transparency工具中关于公开Facebook主页、群组和活动的数据。',
  'social-connection.settings.permission.github.user.help': '仅授予资料信息的读/写访问权限。请注意，此scope包含user:email和user:follow。',
  'social-connection.settings.permission.github.users-follow:write.help': '授予关注或取消关注其他用户的权限。',
  'social-connection.settings.permission.github.repo.help': '授予存储库的完整访问权限，包括对代码、提交状态、存储库和组织项目、邀请、协作者、添加团队成员资格、部署状态以及存储库和组织的存储库Webhook的读/写权限。此外，还授予管理用户项目的能力。',
  'social-connection.settings.permission.github.repo:status.help': '授予对公开和私密存储库中提交状态的读/写权限。此scope仅对于在不授予代码访问权限的情况下授权其他用户或服务访问私密存储库的提交状态时为必需。',
  'social-connection.settings.permission.github.repo_deployment.help': '授予对公开和私密scope的部署状态的访问权限。此scope仅对于在不授予代码访问权限的情况下授权其他用户或服务访问部署状态时为必需。',
  'social-connection.settings.permission.github.public_repo.help': '限制对公开存储库的访问权限，包括对公开存储库和组织的代码、提交状态、存储库项目、协作者及部署状态的读/写权限。此外，它对于将公开存储库标星为必需。',
  'social-connection.settings.permission.github.repo:invite.help': '授予接受/拒绝存储库协作邀请的能力。此scope仅对于在不授予代码访问权限的情况下授权其他用户或服务对邀请的访问权限时为必需。',
  'social-connection.settings.permission.github.security_events.help': '授予：对代码扫描API中安全性事件的读写权限；对密钥扫描API中安全性事件的读写权限；此scope仅对于在不授予代码访问权限的情况下授权其他用户或服务对安全性事件的访问权限时为必需。',
  'social-connection.settings.permission.github.admin:repo_hook.help': '授予对公开或私密存储库中存储库钩子的读取、写入、Ping和删除权限。repo和public_repo scope授予对包括存储库钩子在内的完整存储库访问权限。请使用admin:repo_hook scope限制仅可对存储库钩子进行访问。',
  'social-connection.settings.permission.github.write:repo_hook.help': '授予对公开或私密存储库中钩子的读取、写入和Ping权限。',
  'social-connection.settings.permission.github.read:repo_hook.help': '授予对公开或私密存储库中钩子的读取和Ping权限。',
  'social-connection.settings.permission.github.admin:org.help': '完全管理组织及其团队、项目和成员资格。',
  'social-connection.settings.permission.github.write:org.help': '对组织成员资格、组织项目和团队成员资格的读写权限。',
  'social-connection.settings.permission.github.read:org.help': '对组织成员资格、组织项目和团队成员资格的只读权限。',
  'social-connection.settings.permission.github.admin:public_key.help': '完全管理公钥。',
  'social-connection.settings.permission.github.write:public_key.help': '创建、列示及查看公钥的详细信息。',
  'social-connection.settings.permission.github.read:public_key.help': '列示和查看公钥的详细信息。',
  'social-connection.settings.permission.github.admin:org_hook.help': '授予对组织钩子的读取、写入、Ping和删除权限。注：OAuth令牌仅可由OAuth应用创建的组织钩子执行上述操作。个人访问令牌仅可对用户创建的组织钩子执行上述操作。',
  'social-connection.settings.permission.github.gist.help': '授予对Gist的写入权限。',
  'social-connection.settings.permission.github.notifications.help': '授予：对用户通知的读取权限；对帖子的标记已读权限；对存储库的关注和取消关注权限；对帖子订阅的读取、写入和删除权限。',
  'social-connection.settings.permission.github.delete_repo.help': '授予所管理的存储库的删除权限。',
  'social-connection.settings.permission.github.write:discussion.help': '允许读写团队讨论。',
  'social-connection.settings.permission.github.read:discussion.help': '允许读取团队讨论。',
  'social-connection.settings.permission.github.write:packages.help': '授予在GitHub Packages中上传或发布包的权限。详细信息请参阅“发布包”。',
  'social-connection.settings.permission.github.read:packages.help': '授予从GitHub Packages下载或安装包的权限。详细信息请参阅“安装包”。',
  'social-connection.settings.permission.github.delete:packages.help': '授予删除GitHub Packages的包的权限。详细信息请访问“删除和恢复包”。',
  'social-connection.settings.permission.github.admin:gpg_key.help': '完全管理GPG密钥。',
  'social-connection.settings.permission.github.write:gpg_key.help': '创建、列示及查看GPG密钥的详细信息。',
  'social-connection.settings.permission.github.read:gpg_key.help': '列示和查看GPG密钥的详细信息。',
  'social-connection.settings.permission.github.codespace.help': '授予创建和管理代码空间的能力。代码空间可能曝露有一组不同scope的GITHUB_TOKEN。详细信息请参阅“代码空间中的安全性”。',
  'social-connection.settings.permission.github.workflow.help': '授予添加和更新GitHub Actions工作流文件的能力。如果同一文件（路径和内容均相同）存在于同一存储库的其他分支中，可以在没有此scope的情况下提交工作流文件。工作流文件可能曝露有一组不同scope的GITHUB_TOKEN。',
  'social-connection.settings.permission.google.cloud-platform.help': '查看和管理您在Google云端平台服务中的数据。',
  'social-connection.settings.permission.google.adsense.help': '查看和管理您的AdSense数据。',
  'social-connection.settings.permission.google.analytics.help': '查看和管理您的Google Analytics（分析）数据。',
  'social-connection.settings.permission.google.appengine:admin.help': '查看和管理您在Google App Engine上部署的应用程序。',
  'social-connection.settings.permission.google.mail:send.help': '读、写、发送及永久删除您Gmail中的邮件。',
  'social-connection.settings.permission.google.bigquery.help': '查看和管理您在Google BigQuery中的数据。',
  'social-connection.settings.permission.google.blogger.help': '管理您的Blogger帐户。',
  'social-connection.settings.permission.google.books.help': '管理您的图书。',
  'social-connection.settings.permission.google.calendar:write.help': '查看、编辑、分析及永久删除可通过GOOG日历访问的所有日历。',
  'social-connection.settings.permission.google.ddmconversions.help': '管理DoubleClick Digital Marketing转化跟踪。',
  'social-connection.settings.permission.google.bigtable.help': '管理您的Cloud Bigtable表和集群。',
  'social-connection.settings.permission.google.content.help': '管理您在Google Shopping的产品列表和帐户。',
  'social-connection.settings.permission.google.display-video.help': '创建、查看、编辑及永久删除您的Display & Video 360实体文件和报告。',
  'social-connection.settings.permission.google.doubleclickbidmanager.help': '查看和管理您在DoubleClick Bid Manager中的报告。',
  'social-connection.settings.permission.google.files:write.help': '查看、编辑、创建和删除您的Google Drive文件。',
  'social-connection.settings.permission.google.firebase.help': '查看和管理您的全部Firebase数据和设置。',
  'social-connection.settings.permission.google.fitness.help': '查看及添加您的Google健身身体活动数据。',
  'social-connection.settings.permission.google.ediscovery.help': '管理您的eDiscovery数据。',
  'social-connection.settings.permission.google.classroom.help': '管理您的Google Classroom课程。',
  'social-connection.settings.permission.google.documents.help': '查看和管理您Google文档中的文件。',
  'social-connection.settings.permission.google.androidpublisher.help': '查看和管理您的Google Play Developer帐户。',
  'social-connection.settings.permission.google.games.help': '创建、编辑、删除您的Google Play Games活动。',
  'social-connection.settings.permission.google.webmasters.help': '查看和管理您已验证的网站的Search Console数据。',
  'social-connection.settings.permission.google.presentations.help': '查看和管理您Google幻灯片中的演示文稿。',
  'social-connection.settings.permission.google.spreadsheets.help': '查看、编辑、创建删除您Google Drive中的电子表格。',
  'social-connection.settings.permission.google.manufacturercenter.help': '管理您Google Manufacturer Center的产品列表。',
  'social-connection.settings.permission.google.contacts:write.help': '查看、编辑、下载及永久删除您的联系人。',
  'social-connection.settings.permission.google.photoslibrary.help': '查看和管理您的Google相册。',
  'social-connection.settings.permission.google.tagmanager.help': '管理您的Google Tag Manager容器及其子组件，版本控制和发布除外。',
  'social-connection.settings.permission.google.tasks.help': '创建、编辑、组合和删除您的所有任务。',
  'social-connection.settings.permission.google.youtube.help': '管理您的YouTube帐户。',
  'social-connection.settings.permission.kakao.friends.help': 'Kakao Talk的好友信息。',
  'social-connection.settings.permission.kakao.plusfriends.help': 'Relationship between a Kakao Talk Channel and a user.',
  'social-connection.settings.permission.kakao.story:read.help': '读取Kakao Talk帖文。',
  'social-connection.settings.permission.kakao.story:publish.help': '在KakaoStory中发帖。',
  'social-connection.settings.permission.kakao.talk:message.help': '在KakaoTalk中发送消息。',
  'social-connection.settings.permission.linkedin.social-user:write.help': '代表已认证会员发帖、评论及点赞。',
  'social-connection.settings.permission.linkedin.social-org:write.help': '代表组织发帖、评论及点赞。',
  'social-connection.settings.permission.linkedin.social-org:read.help': '检索组织的帖文、评论和赞。',
  'social-connection.settings.permission.linkedin.ads:write.help': '管理和读取已认证会员的广告帐户。',
  'social-connection.settings.permission.linkedin.ads:read.help': '读取已认证会员的广告帐户。',
  'social-connection.settings.permission.linkedin.ads-report:read.help': '检索广告帐户的报告。',
  'social-connection.settings.permission.linkedin.ads-leads:read.help': '访问已认证会员的销售线索表格及检索销售线索。',
  'social-connection.settings.permission.linkedin.connections-1st:view.help': '线索已认证用户的一度人脉联系人数量。',
  'social-connection.settings.permission.linkedin.audience:write.help': '创建和管理匹配audience。',
  'social-connection.settings.permission.mailru.photoslibrary.help': '查看和管理用户的相册。',
  'social-connection.settings.permission.mailru.guestbook.help': '管理用户留言列表的条目。',
  'social-connection.settings.permission.mailru.pages-posts:write.help': '向用户的\"What\'s New\" Feed中发布内容。',
  'social-connection.settings.permission.mailru.messages:write.help': '访问用户的私信。',
  'social-connection.settings.permission.mailru.calendar:read.help': '访问用户\"My World\"中的活动。',
  'social-connection.settings.permission.microsoft.user.help': '允许应用读取已登录用户的完整资料。此外，还允许应用代表已登录用户更新其资料信息。',
  'social-connection.settings.permission.microsoft.users.help': '允许应用代表已登录用户读写一组完整的资料属性、报告以及您组织内其他用户的经理。此外，还允许应用代表已登录用户创建、删除用户及重置用户密码。',
  'social-connection.settings.permission.microsoft.users:invite.help': '允许应用代表已登录用户邀请访客用户加入您的组织。',
  'social-connection.settings.permission.microsoft.users:export.help': '允许应用导出组织用户的数据（仅限公司管理员操作时）。',
  'social-connection.settings.permission.microsoft.users:manage.help': '允许应用程序读取、更新及删除已登录用户可访问的用户帐户关联的身份。这可以控制您的用户登录时使用的身份。',
  'social-connection.settings.permission.microsoft.activities:read.help': '允许应用读取已登录用户的活动统计数据，例如该用户花在邮件、会议及聊天会话上的时间。',
  'social-connection.settings.permission.microsoft.apps:read.help': '允许应用读取应用目录中的应用。',
  'social-connection.settings.permission.microsoft.apps:write.help': '允许应用创建、读取、上传及删除应用目录中的应用。',
  'social-connection.settings.permission.microsoft.logs:read.help': '允许应用代表已登录用户读取和查询审核日志活动。',
  'social-connection.settings.permission.microsoft.bookings:read.help': '用于只读应用程序。典型目标用户是预订行业的客户。',
  'social-connection.settings.permission.microsoft.bookings:write.help': '允许应用具有完整访问权限。用于提供完整的管理体验。典型目标用户是组织中的管理员。',
  'social-connection.settings.permission.microsoft.calendar:read.help': '允许应用读取用户日历中的活动。',
  'social-connection.settings.permission.microsoft.calendar:write.help': '允许应用创建、读取、上传及删除用户日历中的活动。',
  'social-connection.settings.permission.microsoft.call.help': '允许应用在没有登录用户的情况下，向单个用户发起播出通话并将通话转接到组织目录中的用户。',
  'social-connection.settings.permission.microsoft.call-group.help': '允许应用在没有登录用户的情况下，向多个用户发起播出通话并向组织中的会议添加参与者。',
  'social-connection.settings.permission.microsoft.messages:read.help': '允许应用代表您读取Microsoft Teams中的一对一聊天或群聊消息。',
  'social-connection.settings.permission.microsoft.messages:write.help': '允许应用代表您读取及发送Microsoft Teams中的一对一聊天或群聊消息。',
  'social-connection.settings.permission.microsoft.contacts:read.help': '允许应用读取用户联系人。',
  'social-connection.settings.permission.microsoft.contacts:write.help': '允许应用创建、读取、上传及删除用户联系人。',
  'social-connection.settings.permission.microsoft.device:read.help': '允许应用代表已登录用户读取用户设备列表。',
  'social-connection.settings.permission.microsoft.files:read.help': '允许应用读取已登录用户的文件。',
  'social-connection.settings.permission.microsoft.files:write.help': '允许应用读取、创建、更新和删除已登录用户的文件。',
  'social-connection.settings.permission.microsoft.mail:read.help': '允许应用读取用户邮箱中的邮件。',
  'social-connection.settings.permission.microsoft.mail:write.help': '允许应用创建、读取、更新和删除用户邮箱中的邮件。不包含发邮件的权限。',
  'social-connection.settings.permission.microsoft.mail:send.help': '允许应用以组织中用户的身份发邮件。',
  'social-connection.settings.permission.microsoft.notes:read.help': '允许应用代表已登录用户读取OneNote笔记本和分区的标题，以及创建新的页面、笔记本和分区。',
  'social-connection.settings.permission.microsoft.notes:write.help': '允许应用代表已登录用户读取、共享和修改OneNote笔记本。',
  'social-connection.settings.permission.microsoft.presence:read.help': '允许应用代表已登录用户读取状态信息。状态信息包括活动、是否有空、状态备注、日历中的外出消息、时区和位置。',
  'social-connection.settings.permission.microsoft.presence:write.help': '允许应用代表已登录用户读取状态信息及写入活动和空闲状态。状态信息包括活动、是否有空、状态备注、日历中的外出消息、时区和位置。',
  'social-connection.settings.permission.microsoft.tasks:read.help': '允许应用读取已登录用户的任务和任务列表，包括分享给用户的任务。不包含创建、删除或更新任何任务的权限。',
  'social-connection.settings.permission.microsoft.tasks:write.help': '允许应用创建、读取、更新和删除已登录用户的任务和任务列表，包括分享给用户的任务。',
  'social-connection.settings.permission.ok.photos.help': '访问用户的照片。',
  'social-connection.settings.permission.ok.groups.help': '访问用户群组。',
  'social-connection.settings.permission.ok.videos.help': '访问用户的视频',
  'social-connection.settings.permission.ok.application:invite.help': '使用friends.appInvite方法邀请好友加入游戏的权限。',
  'social-connection.settings.permission.reddit.user.help': '更新偏好和相关帐户信息。没有邮件或密码的访问权限。',
  'social-connection.settings.permission.reddit.credits.help': '将我的Reddit金积分用于授予其他用户金表彰。',
  'social-connection.settings.permission.reddit.pages-engagement:write.help': '编辑和删除我的评论和提交。',
  'social-connection.settings.permission.reddit.flair.help': '选择我的社区标签。更改我提交内容的链接标签。',
  'social-connection.settings.permission.reddit.votes:read.help': '访问我的投票历史记录以及我保存或隐藏的评论和提交。',
  'social-connection.settings.permission.reddit.live-threads:read.help': '管理我参与的实时讨论帖的设置和参与者。',
  'social-connection.settings.permission.reddit.modconfig.help': '管理我所管理社区的配置、侧边栏和CSS。',
  'social-connection.settings.permission.reddit.modcontributors.help': '将用户加入已批准用户列表中或从中删除，以及封禁/解封或禁言/取消禁言我所管理社区中的用户。',
  'social-connection.settings.permission.reddit.modflair.help': '管理和分配我管理的社区的标签。',
  'social-connection.settings.permission.reddit.modlog.help': '访问我所管理社区的审核记录。',
  'social-connection.settings.permission.reddit.modmail.help': '通过mod.reddit.com访问和管理Modmail。',
  'social-connection.settings.permission.reddit.modothers.help': '从我所管理的社区邀请或删除其他版主。',
  'social-connection.settings.permission.reddit.modposts.help': '批准、删除、标记为nsfw以及突出我所管理的社区中的内容。',
  'social-connection.settings.permission.reddit.modself.help': '接受管理社区的邀请。移除自己在所管理或参与的社区中的版主或贡献者的身份。',
  'social-connection.settings.permission.reddit.modwiki.help': '更改我所管理社区的Wiki页面的编辑者和可见性。',
  'social-connection.settings.permission.reddit.mysubreddits.help': '访问我所管理、参与及订阅的社区的列表。',
  'social-connection.settings.permission.reddit.messages:write.help': '访问我的收件箱及向其他用户发送私信。',
  'social-connection.settings.permission.reddit.pages-engagement:read.help': '通过我的帐户访问帖子和评论。',
  'social-connection.settings.permission.reddit.report.help': '报告违规内容。隐藏和显示单个的提交。',
  'social-connection.settings.permission.reddit.save.help': '保存和取消保存评论和提交。',
  'social-connection.settings.permission.reddit.structuredstyles.help': '编辑我所管理社区的结构样式。',
  'social-connection.settings.permission.reddit.submit.help': '从我的帐户提交链接和评论。',
  'social-connection.settings.permission.reddit.subscribe.help': '管理我的社区订阅。管理“好友”（我所关注内容的作者）。',
  'social-connection.settings.permission.reddit.vote.help': '提交和更改我对评论和提交的投票。',
  'social-connection.settings.permission.reddit.wiki:edit.help': '代表我编辑Wiki页面。',
  'social-connection.settings.permission.reddit.wiki:read.help': '通过我的帐户读取Wiki页面。',
  'social-connection.settings.permission.twitch.user.help': '管理用户对象。',
  'social-connection.settings.permission.twitch.users-follow:read.help': '查看用户关注的频道列表。',
  'social-connection.settings.permission.twitch.user-subscriptions:read.help': '查看已授权用户是否订阅了特定频道。',
  'social-connection.settings.permission.twitch.user-block:read.help': '查看用户的拦截列表。',
  'social-connection.settings.permission.twitch.user-block:write.help': '管理用户的拦截列表。',
  'social-connection.settings.permission.twitch.bits:read.help': '查看频道的呼币信息。',
  'social-connection.settings.permission.twitch.analytics-extensions.help': '查看该认证帐户的Twitch扩展分析数据。',
  'social-connection.settings.permission.twitch.analytics-games.help': '查看该认证帐户的游戏分析数据。',
  'social-connection.settings.permission.twitch.channel:edit:commercial.help': '在频道中播广告。',
  'social-connection.settings.permission.twitch.channel:manage:broadcast.help': '管理频道的广播设置，包括上传频道配置及管理直播标记和直播标签。',
  'social-connection.settings.permission.twitch.channel:manage:extensions.help': '管理频道的扩展配置，包括激活扩展。',
  'social-connection.settings.permission.twitch.channel:manage:polls.help': '管理频道的投票。',
  'social-connection.settings.permission.twitch.channel:manage:predictions.help': '管理频道的忠诚点数预测。',
  'social-connection.settings.permission.twitch.channel:manage:redemptions.help': '管理频道的忠诚点数自定义奖励及其兑换。',
  'social-connection.settings.permission.twitch.channel:manage:schedule.help': '管理频道的直播排期。',
  'social-connection.settings.permission.twitch.channel:manage:videos.help': '管理频道的视频，包括删除视频。',
  'social-connection.settings.permission.twitch.channel:read:editors.help': '查看频道中有编辑者角色的用户。',
  'social-connection.settings.permission.twitch.channel:read:goals.help': '查看频道的创作者目标。',
  'social-connection.settings.permission.twitch.channel:read:hype_train.help': '查看频道的Hype Train信息。',
  'social-connection.settings.permission.twitch.channel:read:polls.help': '查看频道的投票。',
  'social-connection.settings.permission.twitch.channel:read:predictions.help': '查看频道的忠诚点数预测。',
  'social-connection.settings.permission.twitch.channel:read:redemptions.help': '查看频道的忠诚点数自定义奖励及其兑换。',
  'social-connection.settings.permission.twitch.channel:read:stream_key.help': '查看授权用户的直播密钥。',
  'social-connection.settings.permission.twitch.channel:read:subscriptions.help': '查看频道的全部订阅者列表，检查用户是否订阅了某个频道。',
  'social-connection.settings.permission.twitch.clips:edit.help': '管理频道的剪辑。',
  'social-connection.settings.permission.twitch.moderation:read.help': '查看频道的审核数据，包括审核者、封禁、暂时禁言和Automod设置。',
  'social-connection.settings.permission.twitch.moderator:manage:banned_users.help': '封禁和解封用户。',
  'social-connection.settings.permission.twitch.moderator:read:blocked_terms.help': '查看主播的禁用词列表。',
  'social-connection.settings.permission.twitch.moderator:manage:blocked_terms.help': '管理主播的禁用词列表。',
  'social-connection.settings.permission.twitch.moderator:manage:automod.help': '管理Automod在您作为审核者的频道中拦截供审核的消息。',
  'social-connection.settings.permission.twitch.moderator:read:automod_settings.help': '查看主播的AutoMod设置。',
  'social-connection.settings.permission.twitch.moderator:manage:automod_settings.help': '管理主播的AutoMod设置。',
  'social-connection.settings.permission.twitch.moderator:read:chat_settings.help': '查看主播的聊天室设置。',
  'social-connection.settings.permission.twitch.moderator:manage:chat_settings.help': '管理主播的聊天室设置。',
  'social-connection.settings.permission.vimeo.promo-codes:vimeo.help': '添加、删除和查看Vimeo On Demand推广。',
  'social-connection.settings.permission.vimeo.upload:vimeo.help': '上传视频。',
  'social-connection.settings.permission.vimeo.interact:vimeo.help': '与Vimeo资源交互，例如给视频点赞或关注某个会员。',
  'social-connection.settings.permission.vimeo.delete:vimeo.help': '删除包括视频在内的现有Vimeo资源。',
  'social-connection.settings.permission.vimeo.edit:vimeo.help': '编辑包括视频在内的现有Vimeo资源。',
  'social-connection.settings.permission.vimeo.create:vimeo.help': '新建展示、群组、频道、作品集等Vimeo资源。要新建视频，需要上传scope。',
  'social-connection.settings.permission.vimeo.purchased:vimeo.help': '访问会员的Vimeo On Demand购买历史记录。',
  'social-connection.settings.permission.vimeo.files:write.help': '访问Vimeo Pro会员或更高级会员拥有的视频文件。',
  'social-connection.settings.permission.vk.notify.help': '用户已允许向其发送通知（用于flash/iframe应用程序）。',
  'social-connection.settings.permission.vk.relationships:read.help': '访问好友。',
  'social-connection.settings.permission.vk.photos.help': '访问照片。',
  'social-connection.settings.permission.vk.audio.help': '访问音频录音。',
  'social-connection.settings.permission.vk.videos.help': '访问视频录像。',
  'social-connection.settings.permission.vk.stories.help': '访问好友。',
  'social-connection.settings.permission.vk.posts.help': '访问Wiki页面。',
  'social-connection.settings.permission.vk.status.help': '访问用户状态。',
  'social-connection.settings.permission.vk.notes.help': '访问笔记。',
  'social-connection.settings.permission.vk.messages:write.help': '访问操作消息的高级方法（仅适用于独立应用程序，[passed moderation] (reference / roadmap)）。',
  'social-connection.settings.permission.vk.wall.help': '访问常见和高级墙技术。此访问权限默认对网站不提供。',
  'social-connection.settings.permission.vk.ads:write.help': '访问与广告API的高级交互方法。适用于隐式流或授权代码流机制的授权。',
  'social-connection.settings.permission.vk.offline.help': '随时访问API（使用此选项时，与access_token一同返回的expires_in参数包含值0，即一个无限制令牌）。不适用于Open API。',
  'social-connection.settings.permission.vk.files.help': '访问文档。',
  'social-connection.settings.permission.vk.groups.help': '访问用户群组。',
  'social-connection.settings.permission.vk.notifications.help': '访问关于用户响应的通知。',
  'social-connection.settings.permission.vk.groups:stats.help': '访问用户在其中是管理员的群组和应用的统计数据。',
  'social-connection.settings.permission.vk.market.help': '访问商品。',
  'social-connection.settings.permission.weibo.all.help': '请求下方所有scope权限。',
  'social-connection.settings.permission.weibo.messages:write.help': '私信发送接口。',
  'social-connection.settings.permission.weibo.messages:read.help': '私信读取接口。',
  'social-connection.settings.permission.weibo.application:invite.help': '邀请发送接口。',
  'social-connection.settings.permission.weibo.groups:read.help': '好友分组读取接口组。',
  'social-connection.settings.permission.weibo.groups:write.help': '好友分组写入接口组。',
  'social-connection.settings.permission.weibo.status.help': '定向微博读取接口组。',
  'social-connection.settings.permission.yahoo.contacts:read.help': '联系人。',
  'social-connection.settings.permission.yahoo.contacts:write.help': '联系人。',
  'social-connection.settings.permission.yahoo.fantasy-sport:read.help': 'Fantasy Sports。',
  'social-connection.settings.permission.yahoo.fantasy-sport:write.help': 'Fantasy Sports。',
  'social-connection.settings.permission.yahoo.finance:read.help': '财经。',
  'social-connection.settings.permission.yahoo.finance:write.help': '财经。',
  'social-connection.settings.permission.yahoo.ads:write.help': 'Oath Ad Platforms。',
  'social-connection.settings.permission.yahoo.ads-publishers:read.help': '面向内容商的Oath Ad Platforms。',
  'social-connection.settings.permission.yahoo.messages:write.help': 'Messenger。',

  'legal-settings.breadcrumb.label': '法律设置',
  'legal-settings.tabs.terms-and-policies': '条款和政策',
  'legal-settings.tabs.age-restrictions': '年龄限制',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=407%3A32764
  'terms-and-policies.settings.title': '条款和政策',
  'terms-and-policies.settings.subtitle': '提供条款和政策的链接以确保合规及定义与用户的法律关系。用户将在登录管理器小组件屏幕上看到这些链接。',
  'terms-and-policies.tos-url.input.title': '服务条款URL（必填）',
  'terms-and-policies.privacy-policy-url.input.title': '隐私政策URL',
  'terms-and-policies.cookies-policy-url.input.title': 'Cookie政策URL',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=8380%3A132843
  'age-restrictions.settings.title': '年龄限制',
  'age-restrictions.settings.subtitle': '设置您登录管理器项目的年龄限制。艾克索拉会存储用户的出生日期，因此注册用户无需采取额外步骤。',
  'age-restrictions.settings.notification': '如设置了年龄限制，用户在注册时需通过小组件中的一个输入字段提供其出生日期。需在<a>补充用户信息设置</a>中启用该字段。',
  'age-restrictions.settings.all-countries.label': '最低年龄要求 | 全部国家/地区',
  'age-restrictions.settings.specific-countries.label': '针对指定国家的年龄限制',
  'age-restrictions.settings.specific-countries.placeholder': '选择国家/地区',
  'age-restrictions.settings.country.placeholder': '年龄要求',

  // https://www.figma.com/file/3oIM5xJT9Fo03bDv3T4zVe/PA%3A%3A-Login-v2?node-id=5435-99581
  'widget-customization.breadcrumb.label': '自定义',
  'widget-customization.tabs.widget': '小组件',
  'widget-customization.tabs.email': '邮件',
  'widget-customization.tabs.sms': '短信',
  'widget-customization.settings.title': '小组件自定义',
  'widget-customization.settings.subtitle': '创建并自定义用户注册和登录小组件。',
  'widget-customization.settings.bar.label': '小组件',
  'widget-customization.settings.bar.select-method.passwordless': '免密登录',
  'widget-customization.settings.bar.select-method.classic': '经典登录',
  'widget-customization.settings.bar.select-method.social': '社交网络登录',
  'widget-customization.settings.bar.select-mode': '预览',
  'widget-customization.settings.bar.customize': '自定义',
  'widget-customization.settings.preview-code.copy': '复制代码',
  'widget-customization.settings.language.title': '语言',
  'widget-customization.settings.language.description': '您可以在提供的语言中为小组件选择一种语言。',
  'widget-customization.settings.language.notification': '您也可以使用小组件初始化代码中的<o>preferredLocale</o>选项来更改语言。<br></br>如果未选择任何语言，将根据用户的IP地址自动设置。',
  'widget-customization.settings.provided-language.title': '可用语言',
  'widget-customization.settings.provided-language.description': '<a>了解语言实现的详细信息</a>。',
  'widget-customization.settings.placeholder.autodetected': '自动检测',
  'widget-customization.settings.country.title': '国家/地区',
  'widget-customization.settings.country.description': '选择一个国家/地区查看适用于该国家/地区的社交网络列表，按最常用到最不常用排列。',
  'widget-customization.settings.country.notification': '<a>打开社交网络排序</a>自定义社交网络的顺序。',
  'widget-customization.settings.country-select.title': '国家/地区',
  'widget-customization.settings.oauth.title': 'OAuth 2.0客户端',
  'widget-customization.settings.oauth.description': '可从已为小组件创建的OAuth 2.0客户端中指定一个。',
  'widget-customization.settings.oauth.dropdown.none': '无',
  'widget-customization.settings.provided-oauth.title': '可用的OAuth 2.0客户端',
  'widget-customization.settings.visual.title': '其他自定义',
  'widget-customization.settings.visual.description': '您的CSS将与小组件编辑器中的样式一起应用。',
  'widget-customization.settings.visual.custom-styles.title': '自定义CSS样式',
  'widget-customization.settings.visual.custom-styles.placeholder': '上传CSS',
  'widget-customization.settings.language-select.language.ru': '俄语',
  "widget-customization.settings.language-select.language.en": "英语",
  "widget-customization.settings.language-select.language.cn": "中文（简体）",
  "widget-customization.settings.language-select.language.ko": "韩语",
  "widget-customization.settings.language-select.language.es": "西班牙语",
  "widget-customization.settings.language-select.language.fr": "法语",
  "widget-customization.settings.language-select.language.pt": "葡萄牙语",
  "widget-customization.settings.language-select.language.it": "意大利语",
  "widget-customization.settings.language-select.language.de": "德语",
  "widget-customization.settings.language-select.language.he": "希伯来语",
  "widget-customization.settings.language-select.language.ar": "阿拉伯语",
  "widget-customization.settings.language-select.language.tw": "中文（繁体）",
  "widget-customization.settings.language-select.language.vi": "越南语",
  "widget-customization.settings.language-select.language.cs": "捷克语",
  "widget-customization.settings.language-select.language.pl": "波兰语",
  "widget-customization.settings.language-select.language.bg": "保加利亚语",
  "widget-customization.settings.language-select.language.ro": "罗马尼亚语",
  "widget-customization.settings.language-select.language.tr": "土耳其语",
  "widget-customization.settings.language-select.language.th": "泰语",
  "widget-customization.settings.language-select.language.ja": "日语",
  "widget-customization.settings.language-select.language.ph": "他加禄语",
  "widget-customization.settings.language-select.language.ne": "尼泊尔语",
  "widget-customization.settings.language-select.language.my": "缅甸语",
  "widget-customization.settings.language-select.language.lo": "老挝语",
  "widget-customization.settings.language-select.language.km": "高棉语",
  "widget-customization.settings.language-select.language.id": "印尼语",
  'widget-customization.old.instruction': '<ul><ol>1. 下载<a1>模板SCSS</a1>。</ol><ol>2. 自定义并生成CSS（详细信息请参阅<a2>指南</a2>）</ol><ol>3. 上传CSS。</ol></ul>',
  'widget-customization.old.upload_css.placeholder': '上传CSS',

  'email-customization.settings.bar.label': '邮件',
  'email-customization.settings.bar.options.verificationCode': '验证邮件（含验证码）',
  'email-customization.settings.bar.options.verificationLinkCode': '验证邮件（含链接和验证码）',
  'email-customization.settings.bar.options.mfaCode': 'MFA验证码邮件',
  'email-customization.settings.bar.options.mfaSettingsChange': 'MFA设置更改邮件',
  'email-customization.settings.bar.options.welcome': '欢迎邮件',
  'email-customization.settings.bar.options.passwordChange': '密码更改邮件',
  'email-customization.settings.bar.options.blockedAccount': '帐户拦截邮件',
  'email-customization.settings.bar.options.registrationConfirm': '注册验证邮件',
  'email-customization.settings.bar.options.emailChange': '邮箱地址更改邮件',
  'email-customization.settings.bar.options.newsSubscribe': '新闻订阅邮件',
  'email-customization.settings.bar.options.custom': '自定义邮件',
  'email-customization.title': '邮件自定义',
  'email-customization.subtitle': '自定义发送给用户的邮件。',
  'email-customization.settings.label': '邮件设置',
  'email-customization.settings.send-from.label': '发件人名称',
  'email-customization.settings.send-from.footer': '该名称是收件人收到您的邮件时看到的名称。',
  'email-customization.settings.send-from.placeholder': 'no-reply@xsolla.com',
  'email-customization.settings.send-from.notification': '如未自定义邮件，将使用默认艾克索拉模板。',
  'passkey.settings.title': '通行密钥',
  'passkey.settings.subtitle': "通行密钥存储在用户设备上，通过指纹、面容或设备PIN码解锁。它是一种附加的登录方式，不会替代您现有的登录方式。",
  'passkey.settings.usage.title': '使用通行密钥',
  'passkey.settings.usage.subtitle': '启用后，用户登录后可创建通行密钥，下次访问时即可使用该密钥登录。',
  'passkey.settings.toggle.title': '允许使用通行密钥',
  'passkey.settings.toggle.description': '请至少保持启用一种其他登录方式。通行密钥不能作为进入项目的唯一方式。'
};

module.exports = localizations;
